// Mind2Magic CRM — Lead Management Module
// Extracted from index.html Step 12.

import { STAGES, TYPE_LABELS } from './constants.js'
import { store } from './store.js'
import { cleanNum } from './utils/format.js'
import { parseLocalDate } from './utils/date.js'

let foundDup = null

// ========== DUPLICATE DETECTION ==========
function showDupAlert(client, type) {
    if (!client) { document.getElementById('dupAlert').classList.add('hidden'); foundDup = null; return }
    foundDup = client
    const titles = { phone: 'Este teléfono ya existe', email: 'Este email ya existe', titular: 'Este nombre ya existe', contacto: 'Este contacto ya existe' }
    document.getElementById('dupAlertTitle').textContent = titles[type] || 'Posible duplicado'
    document.getElementById('dupMsg').textContent = `Cliente: ${client.titular}`
    document.getElementById('dupHist').textContent = `${client.trips.length} viaje(s): ${client.trips.map(t => t.destination).join(', ')}`
    document.getElementById('dupAlert').classList.remove('hidden')
}
function checkDupByPhone(val) { showDupAlert(window.findDupByPhone(val), 'phone') }
function checkDupByEmail(val) { showDupAlert(window.findDupByEmail(val), 'email') }
function checkDupByName(val, type) { showDupAlert(window.findDupByName(val, type), type) }
function ignoreDup() { document.getElementById('dupAlert').classList.add('hidden') }
function viewDupClient() { if (foundDup) { window.closeModal('newLeadModal'); window.openClient(foundDup.phone || ('name:' + foundDup.titular.toLowerCase())) } }

// ========== NEW LEAD ==========
function saveLead() {
    const { leads, clients, team } = store
    const titular = document.getElementById('fTitular').value.trim()
    const contacto = document.getElementById('fContacto').value.trim()
    const phone = window.normalizePhone(document.getElementById('fTel').value)
    const tipo = document.getElementById('fTipo').value
    let resp = document.getElementById('fResponsable').value
    if (resp === '__otro__') {
        const otro = document.getElementById('fRespOtro').value.trim()
        if (!otro) { window.toast('Ingresa el nombre', 'error'); return }
        team.push({ id: 't_' + Date.now(), nombre: otro, rol: '', email: '' })
        resp = otro; window.populateSelects()
    }
    if (!titular || !tipo || !resp) { window.toast('Completa campos obligatorios', 'error'); return }

    // Guardar estado para undo
    window.saveState('crear lead')

    const clientKey = phone || ('name:' + titular.toLowerCase())
    const canalAlerta = document.getElementById('fCanalAlerta').value
    if (!clients[clientKey]) {
        clients[clientKey] = { titular, contacto, email: document.getElementById('fEmail').value, phone, referido: document.getElementById('fReferido').value, canalAlerta, trips: [], createdAt: new Date() }
    } else {
        // Actualizar canalAlerta si ya existe el cliente
        clients[clientKey].canalAlerta = canalAlerta
    }
    const tripId = 'trip_' + Date.now()
    const platform = getPlatformValue('f')
    const trip = { id: tripId, source: 'Manual', travelDate: document.getElementById('fFechaViaje').value, travelEnd: document.getElementById('fFechaFin').value,
        destination: document.getElementById('fDestino').value || (tipo.charAt(0).toUpperCase() + tipo.slice(1)), type: tipo,
        platform: platform,
        totalVenta: cleanNum(document.getElementById('fCosto').value),
        commission: cleanNum(document.getElementById('fCommTotal').value),
        commission70: cleanNum(document.getElementById('fCommM2M').value),
        abono: cleanNum(document.getElementById('fAbono').value),
        abonado: cleanNum(document.getElementById('fAbonado').value),
        fechaAbono: document.getElementById('fFechaAbono').value || null,
        fechaPagoFinal: document.getElementById('fFechaPagoFinal').value || null,
        viajeros: document.getElementById('fViajeros').value, stage: 'nuevo', progress: 0, responsable: resp }
    clients[clientKey].trips.push(trip)
    const reservationNum = document.getElementById('fReservationNum').value.trim() || null
    leads.push({ id: tripId, clientKey, titular, contacto, phone, email: document.getElementById('fEmail').value, type: tipo, stage: 'nuevo',
        travelDate: trip.travelDate, travelEnd: trip.travelEnd, destination: trip.destination, totalVenta: trip.totalVenta, commission: trip.commission, commission70: trip.commission70,
        abono: trip.abono, abonado: trip.abonado, fechaAbono: trip.fechaAbono, fechaPagoFinal: trip.fechaPagoFinal,
        platform: platform, reservationNum,
        progress: 0, responsable: resp, createdAt: new Date() })
    // Historial: registrar creación
    const newLead = leads[leads.length - 1]
    window.addHistorial(newLead, 'creacion', `Lead creado manualmente — ${tipo}, ${trip.destination || 'sin destino'}`)

    // Sync to Supabase
    window.syncClientToSupabase(clientKey, clients[clientKey])
    window.syncLeadToSupabase(newLead)

    window.renderAll(); window.closeModal('newLeadModal')
    document.getElementById('leadForm').reset(); document.getElementById('dupAlert').classList.add('hidden'); document.getElementById('fRespOtro').classList.add('hidden'); document.getElementById('fPlatformOtro').classList.add('hidden')
    window.toast(`Lead "${titular}" creado`, 'success')
}

// ========== EDIT LEAD ==========
function openEditLead(id) {
    const { leads, historico, clients, currentLeadId } = store
    const l = leads.find(l => l.id === id) || historico.find(h => h.id === id); if (!l) return
    store.currentLeadId = id
    document.getElementById('eLeadId').value = id
    document.getElementById('eTitular').value = l.titular || ''
    document.getElementById('eContacto').value = l.contacto || ''
    document.getElementById('eTel').value = l.phone || ''
    document.getElementById('eEmail').value = l.email || ''
    const c = clients[l.clientKey]
    document.getElementById('eReferido').value = c?.referido || ''
    document.getElementById('eCanalAlerta').value = c?.canalAlerta || 'whatsapp'
    document.getElementById('eResponsable').value = l.responsable || ''
    document.getElementById('eTipo').value = l.type || 'otro'
    document.getElementById('eDestino').value = l.destination || ''
    document.getElementById('eReservationNum').value = l.reservationNum || ''
    document.getElementById('eFechaViaje').value = l.travelDate ? String(l.travelDate).substring(0, 10) : ''
    document.getElementById('eFechaFin').value = l.travelEnd ? String(l.travelEnd).substring(0, 10) : ''
    document.getElementById('eCosto').value = l.totalVenta || ''
    document.getElementById('eCommTotal').value = l.commission || ''
    document.getElementById('eCommM2M').value = l.commission70 || ''
    document.getElementById('eAbono').value = l.abono || ''
    document.getElementById('eAbonado').value = l.abonado || ''
    document.getElementById('eFechaAbono').value = l.fechaAbono ? String(l.fechaAbono).substring(0, 10) : ''
    document.getElementById('eFechaPagoFinal').value = l.fechaPagoFinal ? String(l.fechaPagoFinal).substring(0, 10) : ''
    document.getElementById('eEtapa').value = l.stage || 'nuevo'
    // Cargar platform/operador
    const platformSelect = document.getElementById('ePlatform')
    const platformOtro = document.getElementById('ePlatformOtro')
    const knownPlatforms = ['Disney', 'Disney Cruise Line', 'VAX', 'Expedia TAAP', 'Universal', 'Royal Caribbean', 'MSC Cruises', '']
    if (platformSelect && platformOtro) {
        if (l.platform && !knownPlatforms.includes(l.platform)) {
            // Platform no está en lista → mostrar en "Otro"
            platformSelect.value = '__otro__'
            platformOtro.value = l.platform
            platformOtro.classList.remove('hidden')
        } else {
            platformSelect.value = l.platform || ''
            platformOtro.value = ''
            platformOtro.classList.add('hidden')
        }
    }
    // Configurar checkboxes de pago
    const checkAbono = document.getElementById('eAbonoPagado')
    if (checkAbono) {
        const abonoReq = l.abono || window.calcularAbonoEsperado(l.type, l.totalVenta)
        checkAbono.checked = (l.abonado || 0) >= abonoReq && abonoReq > 0
    }
    const checkbox = document.getElementById('ePagoTodo')
    if (checkbox) {
        checkbox.checked = (l.abonado || 0) >= (l.totalVenta || 0) && (l.totalVenta || 0) > 0
    }

    // Populate global viajeros with steppers + age dropdowns
    // Try formData first, then grupoViajeros (from PDF import)
    let _adultos = parseInt(l.formData?.adultos) || 0
    let _menores = parseInt(l.formData?.menores) || 0
    let _minorAges = l.formData?.edadesMenores || null
    if (!_adultos && !_menores && l.grupoViajeros && l.grupoViajeros.length > 0) {
        _adultos = l.grupoViajeros.filter(v => !v.esMenor).length
        _menores = l.grupoViajeros.filter(v => v.esMenor).length
        _minorAges = l.grupoViajeros.filter(v => v.esMenor).map(v => parseInt(v.edad) || 0)
    }
    document.getElementById('eAdultos').value = _adultos
    document.getElementById('eMenores').value = _menores
    updateMinorAgeDropdowns()
    // Populate existing minor ages into dropdowns
    const rawAges = _minorAges
    if (rawAges) {
        const agesArr = Array.isArray(rawAges) ? rawAges.map(a => parseInt(a)).filter(n => !isNaN(n)) : (typeof rawAges === 'string' ? rawAges.split(',').map(s => parseInt(s.trim())).filter(n => !isNaN(n)) : [])
        const selects = document.querySelectorAll('#eMinorAgesRow select')
        agesArr.forEach((age, i) => { if (selects[i]) selects[i].value = age })
    }

    // Populate viajeros list (editable names + ages)
    // Deep copy to avoid cross-lead contamination — previous lead's viajeros must NOT leak
    _editGrupoViajeros = (l.grupoViajeros || []).map(v => ({ ...v }))
    // Clear previous lead's viajeros DOM BEFORE rendering — otherwise renderViajerosEditList
    // reads stale DOM values from the previous modal (closeModal doesn't clear innerHTML)
    const _vList = document.getElementById('eViajerosList')
    if (_vList) _vList.innerHTML = ''
    renderViajerosEditList()

    // Populate multi-hotel entries
    const hotelsContainer = document.getElementById('eHotelsContainer')
    hotelsContainer.innerHTML = ''
    const hotels = window.ensureHotelsArray(l)
    if (hotels.length === 0) {
        addHotelRow({}, hotelsContainer)
    } else {
        hotels.forEach(h => addHotelRow(h, hotelsContainer))
    }

    // Populate multi-park entries
    const parkContainer = document.getElementById('eParkEntriesContainer')
    parkContainer.innerHTML = ''
    const parkEntries = window.ensureParkEntriesArray(l)
    if (parkEntries.length === 0) {
        addParkEntryRow({}, parkContainer)
    } else {
        parkEntries.forEach(p => addParkEntryRow(p, parkContainer))
    }

    // Populate multi-cruise entries
    const cruiseContainer = document.getElementById('eCruisesContainer')
    cruiseContainer.innerHTML = ''
    const cruises = window.ensureCruisesArray(l)
    if (cruises.length > 0) {
        cruises.forEach(c => addCruiseRow(c, cruiseContainer))
    }

    // Reorder booking sections: cruise leads show cruises first, then hotels, then parks
    const bookingSections = document.getElementById('eBookingSections')
    const cruisesSection = document.getElementById('eCruisesSection')
    const hotelsSection = document.getElementById('eHotelsSection')
    const parksSection = document.getElementById('eParksSection')
    if (bookingSections && cruisesSection) {
        if (l.type === 'crucero' || l.type === 'parques_crucero') {
            cruisesSection.style.order = '1'
            hotelsSection.style.order = '2'
            parksSection.style.order = '3'
        } else {
            hotelsSection.style.order = '1'
            parksSection.style.order = '2'
            cruisesSection.style.order = '3'
        }
    }

    // Update ticket hints based on ages
    updateParkTicketCounts()

    // Populate form data section (read-only)
    const fdSection = document.getElementById('eFormDataSection')
    const fdContent = document.getElementById('eFormDataContent')
    const fd = l.formData && typeof l.formData === 'object' ? l.formData : null
    if (fd && Object.values(fd).some(v => v && v !== 'nan')) {
        const items = []
        const row = (label, val) => { if (val && val !== 'nan') items.push(`<div style="display:flex;gap:8px;margin-bottom:3px;"><span style="color:var(--text-3);min-width:120px;">${label}</span><span style="color:var(--text-1);">${window.escHtml(String(val))}</span></div>`) }
        row('Viajeros', fd.viajeros)
        row('Edades menores', fd.edadesMenores)
        row('Habitaciones', window.fmtHabitaciones(fd))
        row('Camarotes', fd.cabinas)
        row('Días Disney', fd.diasDisney)
        row('Días Universal', fd.diasUniversal)
        row('Parques Universal', fd.parquesUniversal)
        row('Hotel preferido', fd.hotel)
        row('Tipo hotel', fd.tipoHotel)
        row('Noches', fd.noches)
        row('Presupuesto', fd.presupuesto)
        row('Evento especial', fd.eventoEspecial)
        row('Experiencias', fd.experiencias)
        row('Documentos', fd.documentos)
        row('Tiquetes', fd.tiquetes)
        row('Residente FL', fd.residenteFL)
        row('Puertos', fd.puertos)
        row('Destinos crucero', fd.destinos)
        row('Duración', fd.duracion)
        row('Naviera', fd.naviera)
        row('Cabinas', fd.cabinas)
        row('Residencia', fd.residencia)
        row('Destino', fd.destino)
        row('Tipo fecha', fd.tipoFecha)
        row('Rango fechas', fd.rangoFechas)
        row('Req. especial', fd.requerimientoEspecial)
        row('Intereses', fd.intereses)
        row('Cuándo viaja', fd.cuandoViaja)
        row('Notas', fd.notas)
        row('Fuente', fd.fuente)
        fdContent.innerHTML = items.join('')
        fdSection.style.display = items.length ? 'block' : 'none'
    } else {
        fdSection.style.display = 'none'
    }
    window.openModal('editLeadModal')
}

function saveLeadEdit() {
    // Validate: every minor must have an age selected
    const menoresCount = parseInt(document.getElementById('eMenores')?.value) || 0
    if (menoresCount > 0) {
        const selects = document.querySelectorAll('#eMinorAgesRow select')
        for (const s of selects) {
            if (s.value === '') {
                window.toast('Selecciona la edad de cada menor', 'error')
                s.focus()
                s.style.outline = '2px solid var(--red)'
                setTimeout(() => s.style.outline = '', 2000)
                return
            }
        }
    }

    // Validate: max 5 people per hotel room
    const hotelDistRows = document.querySelectorAll('#eHotelsContainer .room-dist-row')
    for (const dr of hotelDistRows) {
        const a = Math.max(0, parseInt(dr.querySelector('[data-field="distAdultos"]')?.value) || 0)
        const m = Math.max(0, parseInt(dr.querySelector('[data-field="distMenores"]')?.value) || 0)
        if (a + m > 5) {
            const habLabel = dr.querySelector('span')?.textContent || 'Habitación'
            window.toast(`${habLabel}: máximo 5 personas por habitación (tiene ${a + m})`, 'error')
            dr.style.outline = '2px solid var(--red)'
            setTimeout(() => dr.style.outline = '', 3000)
            return
        }
    }

    // Validate: max 5 people per cruise cabin
    const cruiseRows = document.querySelectorAll('#eCruisesContainer .cruise-entry-row')
    for (const cr of cruiseRows) {
        const ca = Math.max(0, parseInt(cr.querySelector('[data-field="cabinAdultos"]')?.value) || 0)
        const cm = Math.max(0, parseInt(cr.querySelector('[data-field="cabinMenores"]')?.value) || 0)
        if (ca + cm > 5) {
            const cruiseLabel = cr.querySelector('span')?.textContent || 'Cabina'
            window.toast(`${cruiseLabel}: máximo 5 personas por cabina (tiene ${ca + cm})`, 'error')
            cr.style.outline = '2px solid var(--red)'
            setTimeout(() => cr.style.outline = '', 3000)
            return
        }
    }

    const { leads, historico, clients } = store
    const id = document.getElementById('eLeadId').value, l = leads.find(l => l.id === id) || historico.find(l => l.id === id); if (!l) return

    // Guardar estado para undo
    window.saveState('editar lead')

    // Snapshot before edit for historial
    const _snap = window._snapLead(l)

    const newPhone = window.normalizePhone(document.getElementById('eTel').value)
    const oldKey = l.clientKey, newKey = newPhone || ('name:' + document.getElementById('eTitular').value.toLowerCase())
    l.titular = document.getElementById('eTitular').value.trim()
    l.contacto = document.getElementById('eContacto').value.trim()
    l.phone = newPhone; l.email = document.getElementById('eEmail').value.trim()
    l.type = document.getElementById('eTipo').value
    l.destination = document.getElementById('eDestino').value.trim()
    l.travelDate = document.getElementById('eFechaViaje').value
    l.travelEnd = document.getElementById('eFechaFin').value
    l.totalVenta = cleanNum(document.getElementById('eCosto').value)
    l.commission = cleanNum(document.getElementById('eCommTotal').value)
    l.commission70 = cleanNum(document.getElementById('eCommM2M').value)
    l.abono = cleanNum(document.getElementById('eAbono').value)
    l.abonado = cleanNum(document.getElementById('eAbonado').value)
    l.fechaAbono = document.getElementById('eFechaAbono').value || null
    l.fechaPagoFinal = document.getElementById('eFechaPagoFinal').value || null
    l.responsable = document.getElementById('eResponsable').value
    l.platform = getPlatformValue('e')
    l.reservationNum = document.getElementById('eReservationNum').value.trim() || null

    // Collect multi-hotel and multi-park entries
    l.hotels = collectHotelsFromForm()
    l.parkEntries = collectParkEntriesFromForm()

    // Backward compat: populate old single fields from first entry
    if (l.hotels.length > 0) {
        l.hotel = l.hotels[0].name || null
        if (!l.formData || typeof l.formData !== 'object') l.formData = {}
        if (l.hotels[0].rooms) l.formData.habitaciones = l.hotels[0].rooms
    } else {
        l.hotel = null
    }

    if (l.parkEntries.length > 0) {
        const p0 = l.parkEntries[0]
        l.diasParque = p0.days || null
        l.tipoParque = p0.park || null
        l.tickets = p0.ticketType || null
        l.ticketValidFrom = p0.validFrom || null
        l.ticketValidTo = p0.validTo || null
        l.parkHopper = p0.parkHopper || false
        l.hasDiningPlan = !!p0.diningPlan
        l.reservationNum = l.reservationNum || p0.reservationNum || null
    } else {
        l.diasParque = null; l.tipoParque = null; l.tickets = null
        l.ticketValidFrom = null; l.ticketValidTo = null
        l.parkHopper = false; l.hasDiningPlan = false
    }

    // Store arrays + global viajeros in formData for JSONB persistence
    if (!l.formData || typeof l.formData !== 'object') l.formData = {}
    const _editAdultos = parseInt(document.getElementById('eAdultos').value) || 0
    const _editMenores = parseInt(document.getElementById('eMenores').value) || 0
    const _editAges = getMinorAges()
    if (_editAdultos > 0 || _editMenores > 0) {
        l.formData.adultos = _editAdultos
        l.formData.menores = _editMenores
        l.formData.edadesMenores = _editAges
        l.viajeros = _editMenores > 0 ? `${_editAdultos}A + ${_editMenores}M` : `${_editAdultos}A`
    }
    l.formData.hotels = l.hotels
    l.formData.parkEntries = l.parkEntries
    l.cruises = collectCruisesFromForm()
    l.formData.cruises = l.cruises
    // Build distribucionHabitaciones from hotel distribution + cruise cabin passengers
    const _allDist = []
    ;(l.hotels || []).forEach(h => {
        if (h.distribucion && h.distribucion.length > 0) {
            h.distribucion.forEach(d => _allDist.push(d))
        }
    })
    if (_allDist.length > 0) {
        l.formData.distribucionHabitaciones = _allDist
        delete l.formData.mismaHabitacion // Clean stale form value so distribution takes priority in fmtHabitaciones()
    } else {
        delete l.formData.distribucionHabitaciones
    }
    // Rebuild grupoViajeros from the editable viajeros list
    const _editViajeros = collectViajerosFromForm()
    if (_editViajeros) {
        l.grupoViajeros = _editViajeros
    }
    if (l.grupoViajeros) l.formData.grupoViajeros = l.grupoViajeros

    // AUTO-MOVER ETAPA según el pago (BIDIRECCIONAL)
    const abonoRequerido = l.abono || window.calcularAbonoEsperado(l.type, l.totalVenta)
    const etapaManual = document.getElementById('eEtapa').value

    // Solo auto-mover si está en etapas de pago
    const etapasPago = ['prereserva', 'reserva_abono', 'pago_completo']
    const enEtapaPago = etapasPago.includes(l.stage) || etapasPago.includes(etapaManual)

    if (enEtapaPago) {
        if (l.abonado >= l.totalVenta && l.totalVenta > 0) {
            // Pagó totalidad → Pago Completo
            l.stage = 'pago_completo'
        } else if (l.abonado >= abonoRequerido && l.abonado > 0) {
            // Pagó abono pero no todo → Reserva con Abono
            l.stage = 'reserva_abono'
        } else if (l.abonado < abonoRequerido || l.abonado === 0) {
            // No ha pagado abono completo → Pre-Reserva
            l.stage = 'prereserva'
        }
    } else {
        // Si no está en etapa de pago, respetar selección manual
        // Track cotización revision rounds
        if (l.stage === 'cotizacion' && etapaManual === 'revision_cotizacion') {
            l.cotizacionRevisions = (l.cotizacionRevisions || 0) + 1
        }
        l.stage = etapaManual
    }

    // AUTO-MOVER ETAPA según fechas de viaje (finalizado / en_destino / historico)
    // Cancelado never overridden. Postventa preserved unless trip is 180+ days old (→ historico).
    if (l.travelDate && l.stage !== 'cancelado' && l.stage !== 'no_califica' && l.stage !== 'no_compro') {
        const td = parseLocalDate(l.travelDate)
        const te = l.travelEnd ? parseLocalDate(l.travelEnd) : td
        const today = new Date(); today.setHours(0, 0, 0, 0)
        const daysFromEnd = Math.round((te - today) / (1000 * 60 * 60 * 24))
        if (l.stage !== 'postventa') {
            if (today >= td && today <= te) {
                l.stage = 'en_destino'
            } else if (daysFromEnd < 0 && l.stage !== 'finalizado') {
                l.stage = 'finalizado'
            }
        }
        // Historico overrides everything (including postventa) — trip ended 180+ days ago
        if (daysFromEnd < -180) {
            l.stage = 'historico'
            l.isHistorico = true
        }
    }

    l.progress = window.calcProgress(l.stage)

    // Move between leads ↔ historico arrays based on stage
    const wasInHistorico = store.historico.some(x => x.id === l.id)
    if (l.stage === 'historico') {
        l.isHistorico = true
        if (!wasInHistorico) {
            store.leads = store.leads.filter(x => x.id !== l.id)
            store.historico.push(l)
        }
    } else if (wasInHistorico) {
        // Date changed to future — move back to active leads
        l.isHistorico = false
        store.historico = store.historico.filter(x => x.id !== l.id)
        if (!store.leads.find(x => x.id === l.id)) store.leads.push(l)
    }

    if (clients[oldKey]) {
        const c = clients[oldKey]
        c.titular = l.titular; c.contacto = l.contacto; c.phone = newPhone; c.email = l.email
        c.referido = document.getElementById('eReferido').value.trim()
        c.canalAlerta = document.getElementById('eCanalAlerta').value
        const t = c.trips.find(t => t.id === id)
        if (t) {
            t.travelDate = l.travelDate; t.travelEnd = l.travelEnd; t.destination = l.destination; t.type = l.type; t.platform = l.platform; t.totalVenta = l.totalVenta; t.commission = l.commission; t.commission70 = l.commission70; t.abono = l.abono; t.abonado = l.abonado; t.fechaAbono = l.fechaAbono; t.fechaPagoFinal = l.fechaPagoFinal; t.stage = l.stage; t.progress = l.progress; t.responsable = l.responsable; t.reservationNum = l.reservationNum
            // Campos de entradas a parques + multi arrays
            t.diasParque = l.diasParque; t.tipoParque = l.tipoParque; t.tickets = l.tickets; t.ticketValidFrom = l.ticketValidFrom; t.ticketValidTo = l.ticketValidTo; t.parkHopper = l.parkHopper; t.hasDiningPlan = l.hasDiningPlan
            t.hotels = l.hotels; t.parkEntries = l.parkEntries
        }
        if (oldKey !== newKey) { clients[newKey] = c; delete clients[oldKey]; l.clientKey = newKey }
    }

    // Historial: registrar cambios de la edición
    const _editFields = Object.keys(_snap)
    const _editCambios = window._buildCambios(_snap, l, _editFields)
    if (Object.keys(_editCambios).length > 0) {
        const changedLabels = Object.keys(_editCambios).map(f => window._HISTORIAL_FIELD_LABELS[f] || f).join(', ')
        window.addHistorial(l, 'edicion', `Editado: ${changedLabels}`, _editCambios)
    }

    // Sync to Supabase
    window.syncLeadToSupabase(l)
    if (clients[l.clientKey]) window.syncClientToSupabase(l.clientKey, clients[l.clientKey])

    // Clear stale viajeros reference to prevent cross-lead contamination
    _editGrupoViajeros = []

    // Mantener búsqueda activa - NO limpiar el input de búsqueda
    window.renderAll()
    window.closeModal('editLeadModal')
    window.closePanel()

    // Mostrar mensaje de etapa auto-asignada si cambió
    const etapaFinal = STAGES.find(s => s.id === l.stage)?.name || l.stage
    window.toast(`Lead actualizado → ${etapaFinal}`, 'success')
}

// Función para marcar "Abono pagado" en edit mode
function toggleAbonoPagado() {
    const checkbox = document.getElementById('eAbonoPagado')
    const abonoReqInput = document.getElementById('eAbono')
    const abonadoInput = document.getElementById('eAbonado')
    const tipo = document.getElementById('eTipo').value
    const totalVenta = cleanNum(document.getElementById('eCosto').value)
    const abonoReq = cleanNum(abonoReqInput.value) || window.calcularAbonoEsperado(tipo, totalVenta)

    if (checkbox.checked) {
        abonadoInput.value = abonoReq
        // Uncheck "Pagó totalidad" since we're only marking abono
        const checkPago = document.getElementById('ePagoTodo')
        if (checkPago) checkPago.checked = false
    } else {
        abonadoInput.value = ''
    }
    checkAutoStage()
}

// Función para marcar "Pagó totalidad"
function togglePagoTotalidad() {
    const checkbox = document.getElementById('ePagoTodo')
    const totalVenta = cleanNum(document.getElementById('eCosto').value)
    const abonadoInput = document.getElementById('eAbonado')

    if (checkbox.checked) {
        abonadoInput.value = totalVenta
        // Also check abono since totalidad includes abono
        const checkAbono = document.getElementById('eAbonoPagado')
        if (checkAbono) checkAbono.checked = true
    } else {
        abonadoInput.value = ''
        const checkAbono = document.getElementById('eAbonoPagado')
        if (checkAbono) checkAbono.checked = false
    }
    checkAutoStage()
}

// Función para mostrar/ocultar input de Operador "Otro"
function togglePlatformOtro(prefix) {
    const select = document.getElementById(prefix + 'Platform')
    const input = document.getElementById(prefix + 'PlatformOtro')
    if (select.value === '__otro__') {
        input.classList.remove('hidden')
        input.focus()
    } else {
        input.classList.add('hidden')
        input.value = ''
    }
}

// Obtener valor de platform (select o input otro)
function getPlatformValue(prefix) {
    const select = document.getElementById(prefix + 'Platform')
    const input = document.getElementById(prefix + 'PlatformOtro')
    if (select.value === '__otro__') {
        return input.value.trim() || null
    }
    return select.value || null
}

// ========== VIAJEROS STEPPER + AGE DROPDOWNS ==========
function stepViajeros(inputId, delta) {
    const el = document.getElementById(inputId)
    if (!el) return
    const min = parseInt(el.min) || 0
    const max = parseInt(el.max) || 30
    const cur = parseInt(el.value) || 0
    el.value = Math.max(min, Math.min(max, cur + delta))
    if (inputId === 'eMenores') updateMinorAgeDropdowns()
    updateParkTicketCounts()
    renderViajerosEditList()
}

function updateMinorAgeDropdowns() {
    const count = parseInt(document.getElementById('eMenores')?.value) || 0
    const container = document.getElementById('eMinorAgesContainer')
    const row = document.getElementById('eMinorAgesRow')
    if (!container || !row) return

    // Preserve existing ages (keep '' for unset)
    const existing = []
    row.querySelectorAll('select').forEach(s => existing.push(s.value))

    row.innerHTML = ''
    if (count === 0) { container.style.display = 'none'; updateParkTicketCounts(); return }
    container.style.display = 'block'

    for (let i = 0; i < count; i++) {
        const prevVal = existing[i] !== undefined ? existing[i] : ''
        const sel = document.createElement('select')
        sel.className = 'form-select'
        sel.dataset.minorIndex = i
        sel.style.cssText = 'width:64px;padding:4px 6px;font-size:12px;'
        sel.onchange = () => updateParkTicketCounts()
        let opts = '<option value="">--</option>'
        for (let age = 0; age <= 17; age++) {
            const selected = prevVal === String(age) ? ' selected' : ''
            opts += `<option value="${age}"${selected}>${age}</option>`
        }
        sel.innerHTML = opts
        const wrap = document.createElement('div')
        wrap.style.cssText = 'text-align:center;'
        wrap.innerHTML = `<div style="font-size:10px;color:var(--text-3);margin-bottom:2px;">Menor ${i + 1}</div>`
        wrap.appendChild(sel)
        row.appendChild(wrap)
    }
    updateParkTicketCounts()
}

function getMinorAges() {
    const row = document.getElementById('eMinorAgesRow')
    if (!row) return []
    const ages = []
    row.querySelectorAll('select').forEach(s => {
        const v = parseInt(s.value)
        if (!isNaN(v)) ages.push(v)
    })
    return ages
}

// ========== EDITABLE VIAJEROS LIST (name + age per traveler) ==========
// Store grupoViajeros reference when edit modal opens, so renderViajerosEditList can use it as fallback
let _editGrupoViajeros = []

function renderViajerosEditList() {
    const container = document.getElementById('eViajerosListContainer')
    const list = document.getElementById('eViajerosList')
    if (!container || !list) return

    const adultos = parseInt(document.getElementById('eAdultos')?.value) || 0
    const menores = parseInt(document.getElementById('eMenores')?.value) || 0
    const total = adultos + menores

    if (total === 0) { container.style.display = 'none'; list.innerHTML = ''; return }
    container.style.display = 'block'

    // Preserve existing values from DOM
    const existing = []
    list.querySelectorAll('.viajero-row').forEach(row => {
        existing.push({
            nombre: row.querySelector('[data-field="nombre"]')?.value || '',
            edad: row.querySelector('[data-field="edad"]')?.value || '',
            esMenor: row.dataset.esMenor === 'true',
            esTitular: row.dataset.esTitular === 'true'
        })
    })

    // Fallback to grupoViajeros from lead data (for rows not yet in DOM)
    // Separate adults and minors from grupoViajeros to match layout order
    const gvAdults = _editGrupoViajeros.filter(v => !v.esMenor)
    const gvMinors = _editGrupoViajeros.filter(v => v.esMenor)

    list.innerHTML = ''
    // Adults first, then minors
    for (let i = 0; i < total; i++) {
        const isMinor = i >= adultos
        const minorIdx = isMinor ? i - adultos : -1
        let prev = existing[i] || {}
        // If no DOM data, try grupoViajeros fallback
        if (!prev.nombre && _editGrupoViajeros.length > 0) {
            const gvMatch = isMinor ? gvMinors[minorIdx] : gvAdults[i]
            if (gvMatch) prev = { nombre: gvMatch.nombre || '', edad: gvMatch.edad != null ? String(gvMatch.edad) : '', esMenor: gvMatch.esMenor, esTitular: gvMatch.esTitular || false }
        }
        // Get minor age from dropdowns if available
        let ageVal = prev.edad || ''
        if (isMinor && !ageVal) {
            const ageSelects = document.querySelectorAll('#eMinorAgesRow select')
            if (ageSelects[minorIdx]) ageVal = ageSelects[minorIdx].value || ''
        }

        const row = document.createElement('div')
        row.className = 'viajero-row'
        row.dataset.esMenor = isMinor
        row.dataset.esTitular = (i === 0 && !isMinor) ? 'true' : (prev.esTitular || 'false')
        row.style.cssText = 'display:flex;align-items:center;gap:6px;'
        row.innerHTML = `
            <span style="font-size:11px;color:var(--text-3);min-width:18px;">${isMinor ? '<span style="background:var(--purple);color:white;padding:1px 5px;border-radius:8px;font-size:9px;">M</span>' : '👤'}</span>
            <input type="text" data-field="nombre" class="form-input" placeholder="${isMinor ? 'Nombre menor ' + (minorIdx + 1) : (i === 0 ? 'Titular' : 'Adulto ' + (i + 1))}" value="${window.escHtml(prev.nombre)}" style="flex:1;padding:5px 8px;font-size:12px;">
            ${isMinor ? `<input type="number" data-field="edad" class="form-input" placeholder="Edad" value="${window.escHtml(String(ageVal))}" min="0" max="17" style="width:52px;padding:5px 6px;font-size:12px;text-align:center;" onchange="syncMinorAgeFromViajero(this, ${minorIdx})">` : '<input type="hidden" data-field="edad" value="">'}
        `
        list.appendChild(row)
    }
}

function syncMinorAgeFromViajero(input, minorIdx) {
    // Keep minor age dropdown in sync when edited from the viajeros list
    const ageSelects = document.querySelectorAll('#eMinorAgesRow select')
    if (ageSelects[minorIdx]) {
        ageSelects[minorIdx].value = input.value
        updateParkTicketCounts()
    }
}

function collectViajerosFromForm() {
    const list = document.getElementById('eViajerosList')
    if (!list) return null
    const rows = list.querySelectorAll('.viajero-row')
    if (rows.length === 0) return null
    const viajeros = []
    rows.forEach((row, i) => {
        const nombre = row.querySelector('[data-field="nombre"]')?.value?.trim() || ''
        const edadRaw = row.querySelector('[data-field="edad"]')?.value
        const edad = edadRaw !== '' && edadRaw !== undefined ? parseInt(edadRaw) : null
        const esMenor = row.dataset.esMenor === 'true'
        const esTitular = row.dataset.esTitular === 'true'
        viajeros.push({ nombre, edad: esMenor ? (edad || 0) : null, esMenor, esTitular })
    })
    return viajeros.some(v => v.nombre) ? viajeros : null
}

function updateParkTicketCounts() {
    const adultos = parseInt(document.getElementById('eAdultos')?.value) || 0
    const ages = getMinorAges()
    const ticketAdults = adultos + ages.filter(a => a >= 10).length
    const ticketMinors = ages.filter(a => a >= 3 && a < 10).length
    // Auto-fill park entry ticket counts ONLY if empty (don't overwrite saved values)
    document.querySelectorAll('.park-entry-row').forEach(row => {
        const adInput = row.querySelector('[data-field="adultos"]')
        const mnInput = row.querySelector('[data-field="menores"]')
        if (adInput && adInput.value === '') adInput.value = ticketAdults || ''
        if (mnInput && mnInput.value === '') mnInput.value = ticketMinors || ''
    })
}

function stepParkTickets(btn, field, delta) {
    const row = btn.closest('.park-entry-row')
    if (!row) return
    const input = row.querySelector(`[data-field="${field}"]`)
    if (!input) return
    const min = 0, max = field === 'adultos' ? 30 : 20
    const cur = parseInt(input.value) || 0
    input.value = Math.max(min, Math.min(max, cur + delta))
}

// Función para verificar y sugerir etapa según abono
function checkAutoStage() {
    const totalVenta = cleanNum(document.getElementById('eCosto').value)
    const abonado = cleanNum(document.getElementById('eAbonado').value)
    const tipo = document.getElementById('eTipo').value
    const abonoRequerido = cleanNum(document.getElementById('eAbono').value) || window.calcularAbonoEsperado(tipo, totalVenta)
    const etapaSelect = document.getElementById('eEtapa')
    const checkbox = document.getElementById('ePagoTodo')

    // Actualizar checkbox según valor abonado
    if (checkbox) {
        checkbox.checked = (abonado >= totalVenta && totalVenta > 0)
    }

    // Sugerir cambio de etapa BIDIRECCIONAL
    const etapaActual = etapaSelect.value
    const etapasPago = ['prereserva', 'reserva_abono', 'pago_completo']

    if (etapasPago.includes(etapaActual)) {
        if (abonado >= totalVenta && totalVenta > 0) {
            // Pagó todo → Pago Completo
            etapaSelect.value = 'pago_completo'
        } else if (abonado >= abonoRequerido && abonado > 0) {
            // Pagó abono pero no todo → Reserva con Abono
            etapaSelect.value = 'reserva_abono'
        } else if (abonado === 0 || abonado < abonoRequerido) {
            // No ha pagado abono o cambió a menos → Pre-Reserva
            etapaSelect.value = 'prereserva'
        }
    }
}

// ========== FUNCIONES DE PANEL LATERAL PARA PAGOS ==========
function toggleAbonoFromPanel(leadId) {
    const { leads, historico, clients } = store
    const l = leads.find(l => l.id === leadId) || historico.find(l => l.id === leadId)
    if (!l) return

    const abonoRequerido = Math.min(l.abono || window.calcularAbonoEsperado(l.type, l.totalVenta), l.totalVenta || Infinity)
    const yaAbonado = (l.abonado || 0) >= abonoRequerido

    // Check if called from checkbox (modo completo) or button (modo compacto)
    const checkbox = document.getElementById('panelCheckAbono')
    const marcar = checkbox ? checkbox.checked : !yaAbonado

    window.saveState('marcar abono')
    const _prevAbonado = l.abonado || 0
    const _prevStage = l.stage

    if (marcar) {
        l.abonado = abonoRequerido
        l.stage = 'reserva_abono'
        l.progress = window.calcProgress('reserva_abono')
    } else {
        l.abonado = 0
        l.stage = 'prereserva'
        l.progress = window.calcProgress('prereserva')
    }
    window.addHistorial(l, 'pago', marcar ? `Abono registrado: ${window.fmt(l.abonado)}` : 'Abono removido', { abonado: { antes: _prevAbonado, despues: l.abonado }, stage: { antes: _prevStage, despues: l.stage } })

    // Sincronizar con cliente
    const c = clients[l.clientKey]
    if (c) {
        const t = c.trips.find(t => t.id === leadId)
        if (t) {
            t.abonado = l.abonado
            t.stage = l.stage
            t.progress = l.progress
        }
    }

    window.syncLeadToSupabase(l)
    window.renderAll()
    openLead(leadId)
    window.toast(marcar ? `Abono registrado → Reserva con Abono` : `Abono removido → Pre-Reserva`, 'success')
}

function togglePagoTotalFromPanel(leadId) {
    const { leads, historico, clients } = store
    const l = leads.find(l => l.id === leadId) || historico.find(l => l.id === leadId)
    if (!l) return

    const abonoRequerido = Math.min(l.abono || window.calcularAbonoEsperado(l.type, l.totalVenta), l.totalVenta || Infinity)
    const yaPagado = (l.abonado || 0) >= (l.totalVenta || 0) && (l.totalVenta || 0) > 0

    // Check if called from checkbox (modo completo) or button (modo compacto)
    const checkbox = document.getElementById('panelCheckPagoTotal')
    const marcar = checkbox ? checkbox.checked : !yaPagado

    window.saveState('marcar pago completo')
    const prevStage = l.stage
    const _prevAbonado = l.abonado || 0

    if (marcar) {
        l.abonado = l.totalVenta
        l.stage = 'pago_completo'
        l.progress = window.calcProgress('pago_completo')
    } else {
        // Revert to previous stage or reserva_abono if deposit was paid
        l.abonado = abonoRequerido
        const stageIdx = window.getStageIndex(prevStage)
        const abonoIdx = window.getStageIndex('reserva_abono')
        l.stage = (stageIdx > abonoIdx && prevStage !== 'pago_completo') ? prevStage : 'reserva_abono'
        l.progress = window.calcProgress(l.stage)
    }
    window.addHistorial(l, 'pago', marcar ? `Pago completo: ${window.fmt(l.totalVenta)}` : 'Pago completo removido', { abonado: { antes: _prevAbonado, despues: l.abonado }, stage: { antes: prevStage, despues: l.stage } })

    // Sincronizar con cliente
    const c = clients[l.clientKey]
    if (c) {
        const t = c.trips.find(t => t.id === leadId)
        if (t) {
            t.abonado = l.abonado
            t.stage = l.stage
            t.progress = l.progress
        }
    }

    // Actualizar checkbox de abono si existe
    const checkAbono = document.getElementById('panelCheckAbono')
    if (checkAbono) checkAbono.checked = l.abonado >= abonoRequerido

    window.syncLeadToSupabase(l)
    window.renderAll()
    openLead(leadId)
    window.toast(marcar ? `Pago completo registrado` : `Pago completo removido → Reserva con Abono`, 'success')
}

function deleteLead() {
    const { leads, historico, clients } = store
    const id = document.getElementById('eLeadId').value
    if (!confirm('¿Eliminar este lead?')) return

    // Guardar estado para undo
    window.saveState('eliminar lead')

    let idx = leads.findIndex(l => l.id === id)
    let arr = leads
    if (idx === -1) { idx = historico.findIndex(l => l.id === id); arr = historico; }
    if (idx !== -1) {
        const l = arr[idx], c = clients[l.clientKey]
        if (c) { const ti = c.trips.findIndex(t => t.id === id); if (ti !== -1) c.trips.splice(ti, 1); if (!c.trips.length) { window.supabaseDB.deleteClient(l.clientKey); delete clients[l.clientKey] } }
        // Sync delete to Supabase + suppress Realtime re-insert
        if (l._supabaseId) {
            window.supabaseDB.deleteLead(l._supabaseId)
            store._recentSyncs.add(l._supabaseId)
            setTimeout(() => store._recentSyncs.delete(l._supabaseId), 15000)
        } else {
            const suppressKey = `del_${(l.titular || '').toLowerCase()}_${l.phone || ''}`
            store._recentSyncs.add(suppressKey)
            setTimeout(() => store._recentSyncs.delete(suppressKey), 15000)
        }
        arr.splice(idx, 1)
    }
    _editGrupoViajeros = []
    window.renderAll(); window.closeModal('editLeadModal'); window.closePanel()
    window.toast('Lead eliminado', 'success')
}

function editFromPanel() {
    const { currentLeadId } = store
    if (currentLeadId) openEditLead(currentLeadId)
}

function toggleWatchLead() {
    const { leads } = store
    const id = store.currentLeadId
    if (!id) return
    const l = leads.find(l => l.id === id)
    if (!l) return
    if (!l.formData) l.formData = {}
    l.formData.watched = !l.formData.watched
    window.syncLeadToSupabase?.(l)
    const btn = document.getElementById('btnWatchPanel')
    if (btn) btn.textContent = l.formData.watched ? 'Quitar Seg.' : 'Seguimiento'
    window.toast(l.formData.watched ? `${l.titular} agregado a Seguimiento` : `${l.titular} removido de Seguimiento`, l.formData.watched ? 'success' : 'info')
    window.renderAll?.()
}

// ========== CAMBIAR RESPONSABLE DESDE PANEL ==========
function changeResponsableFromPanel(leadId, newResp) {
    const { leads, clients } = store
    const l = leads.find(l => l.id === leadId)
    if (l) {
        const _prevResp = l.responsable
        l.responsable = newResp
        if (_prevResp !== newResp) window.addHistorial(l, 'responsable', `Responsable: ${_prevResp || '—'} → ${newResp}`, { responsable: { antes: _prevResp, despues: newResp } })
        const c = clients[l.clientKey]
        if (c) { const t = c.trips.find(t => t.id === leadId); if (t) t.responsable = newResp }
        window.syncLeadToSupabase(l)
        window.renderPipeline()
        window.toast(`Responsable: ${newResp}`, 'success')
    }
}

// ========== PANEL CON LINEA DE PROGRESO Y DROPDOWN RESPONSABLE ==========
function openLead(id) {
    const { leads, historico, clients, team, modoCompleto } = store
    // Buscar en leads activos o en histórico
    let l = leads.find(l => l.id === id)
    let isHistorico = false
    if (!l) {
        l = historico.find(h => h.id === id)
        isHistorico = true
    }
    if (!l) return

    store.currentLeadId = id
    const c = clients[l.clientKey], t = c?.trips.find(t => t.id === id)
    const stageIdx = isHistorico ? STAGES.length : window.getStageIndex(l.stage)

    // Generar línea de progreso
    const stageProgress = STAGES.map((s, i) => {
        let cls = ''
        if (i < stageIdx) cls = 'done'
        else if (i === stageIdx && !isHistorico) cls = 'active'
        return `<div class="stage-dot ${cls}" title="${s.name}"></div>`
    }).join('') + (isHistorico ? '<div class="stage-dot done" title="Histórico" style="background:#6366f1"></div>' : '')

    // Dropdown responsable
    const respOptions = team.map(tm => `<option value="${tm.nombre}" ${l.responsable === tm.nombre ? 'selected' : ''}>${tm.nombre}</option>`).join('')

    const _pSuId = l._supabaseId || l.id;
    const _pWaSummary = store.waLeadSummaries[_pSuId];
    const _pWaBadge = (_pWaSummary && _pWaSummary.lastDirection === 'in') ? ' <span style="font-size:10px;padding:2px 8px;border-radius:8px;background:rgba(245,158,11,0.2);color:#f59e0b;vertical-align:middle;margin-left:6px;">Pendiente WA</span>' : '';
    document.getElementById('panelTitle').innerHTML = window.escHtml(l.titular) + _pWaBadge
    const watchBtn = document.getElementById('btnWatchPanel')
    if (watchBtn) watchBtn.textContent = l.formData?.watched ? 'Quitar Seg.' : 'Seguimiento'
    document.getElementById('btnEditPanel').classList.toggle('hidden', isHistorico) // Ocultar editar para histórico
    const stageName = isHistorico ? '📦 Histórico' : (STAGES.find(s => s.id === l.stage)?.name || l.stage)
    const stageColor = STAGES.find(s => s.id === l.stage)?.color || '#888'

    // Calculate payment status
    const saldoPendiente = (l.totalVenta || 0) - (l.abonado || 0)
    const isPagado = saldoPendiente <= 0 && (l.totalVenta || 0) > 0
    const tieneAbono = (l.abonado || 0) > 0

    // Payment deadline warnings — only show if abono not yet fully paid
    let fechaAbonoWarning = ''
    const abonoRequerido = l.abono || window.calcularAbonoEsperado(l.type, l.totalVenta)
    const abonoCompleto = (l.abonado || 0) >= abonoRequerido && abonoRequerido > 0
    if (l.fechaAbono && !abonoCompleto) {
        const d = Math.ceil((new Date(l.fechaAbono) - new Date()) / 86400000)
        if (d >= 0 && d <= 7) fechaAbonoWarning = `⚠️ Abono vence en ${d}d`
        else if (d < 0) fechaAbonoWarning = '⚠️ Abono vencido'
    }

    if (modoCompleto) {
        // ========== MODO COMPLETO ==========
        document.getElementById('panelBody').innerHTML = `
            <div class="panel-section">
                <div class="panel-section-title">Progreso</div>
                <div class="stage-progress">${stageProgress}</div>
                <div style="text-align:center;font-size:11px;color:var(--text-2);margin-top:6px;">${stageName}</div>
            </div>
            <div class="panel-section">
                <div class="panel-section-title">Responsable</div>
                <select class="inline-select" onchange="changeResponsableFromPanel('${l.id}', this.value)" ${isHistorico ? 'disabled' : ''}>${respOptions}</select>
            </div>
            <div class="panel-section"><div class="panel-section-title">Personas</div>
                <div class="info-row"><span class="info-label">Titular</span><span class="info-val">${window.escHtml(l.titular)}</span></div>
                ${l.contacto && l.contacto !== l.titular ? `<div class="info-row"><span class="info-label">Contacto</span><span class="info-val">${window.escHtml(l.contacto)}</span></div>` : ''}
                <div class="info-row"><span class="info-label">Teléfono</span><span class="info-val">${window.escHtml(l.phone) || 'Sin registrar'}${(() => { const waPhone = (l.phone || '').replace(/\D/g, ''); return waPhone ? ` <a href="https://wa.me/${waPhone}" target="_blank" rel="noopener" title="Abrir WhatsApp" style="color:#1FA855;text-decoration:none;"><svg width="14" height="14" viewBox="0 0 24 24" fill="#1FA855" style="vertical-align:middle;"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg></a>` : ''; })()}</span></div>
                <div class="info-row"><span class="info-label">Email</span><span class="info-val">${window.escHtml(l.email) || 'Sin registrar'}</span></div>
                ${c?.referido ? `<div class="info-row"><span class="info-label">Referido por</span><span class="info-val">${window.escHtml(c.referido)}</span></div>` : ''}
                <div class="info-row"><span class="info-label">Alertas</span><span class="info-val">${{'whatsapp':'📱 WhatsApp','email':'📧 Email','ambos':'📱📧 Ambos','ninguno':'🔕 Ninguno'}[c?.canalAlerta] || '📱 WhatsApp'}</span></div>
            </div>
            ${(l.grupoViajeros || t?.grupoViajeros) ? `
            <div class="panel-section">
                <div class="panel-section-title" style="display:flex;justify-content:space-between;align-items:center;">
                    <span>👥 Grupo de Viajeros (${(l.grupoViajeros || t?.grupoViajeros).length})</span>
                    <button class="btn btn-xs btn-ghost" onclick="openEditViajeros('${l.id}')" title="Editar viajeros y fechas de nacimiento">✏️</button>
                </div>
                ${(() => {
                    const gv = l.grupoViajeros || t?.grupoViajeros || []
                    const resNums = [...new Set(gv.map(v => v.reservationNum).filter(Boolean))]
                    const renderRow = (v) => '<div class="info-row" style="padding:6px 0;border-bottom:1px solid var(--border);"><span class="info-label" style="display:flex;align-items:center;gap:6px;">' + (v.esTitular ? '⭐' : '👤') + ' ' + window.escHtml(v.nombre) + (v.esMenor ? ' <span style="background:var(--purple);color:white;padding:1px 6px;border-radius:10px;font-size:10px;">M</span>' : '') + (v.fechaNacimiento ? ' <span style="color:var(--text-3);font-size:10px;">🎂 ' + window.fmtDate(v.fechaNacimiento) + '</span>' : '') + '</span><span class="info-val">' + (v.edad ? v.edad + ' años' : (v.esMenor ? '' : 'Adulto')) + '</span></div>'
                    if (resNums.length <= 1) return gv.map(renderRow).join('')
                    // Multi-family: group by reservation
                    const cruises = l.cruises || []
                    return resNums.map(rn => {
                        const members = gv.filter(v => v.reservationNum === rn)
                        const cr = cruises.find(c => c.reservationNum === rn)
                        const label = cr?.titular || rn
                        return '<div style="margin-top:8px;margin-bottom:4px;font-size:11px;font-weight:600;color:#0077b6;">Fam. ' + window.escHtml(label) + ' (' + members.length + ') <span style="font-weight:400;color:var(--cyan);font-family:monospace;">#' + window.escHtml(rn) + '</span></div>' + members.map(renderRow).join('')
                    }).join('')
                })()}
                ${window.fmtViajeros(l, 'panel') ? `<div style="margin-top:8px;font-size:11px;color:var(--text-3);">Composición: ${window.escHtml(window.fmtViajeros(l, 'panel'))}</div>` : (l.viajeros ? `<div style="margin-top:8px;font-size:11px;color:var(--text-3);">Composición: ${window.escHtml(l.viajeros)}</div>` : '')}
            </div>
            ` : (l.viajeros || window.fmtViajeros(l, 'panel') ? `
            <div class="panel-section"><div class="panel-section-title">👥 Viajeros</div>
                <div class="info-row"><span class="info-label">Composición</span><span class="info-val">${window.escHtml(window.fmtViajeros(l, 'panel') || l.viajeros)}</span></div>
                <button class="btn btn-xs btn-ghost" onclick="openEditViajeros('${l.id}')" style="margin-top:8px;">➕ Agregar viajeros</button>
            </div>
            ` : `
            <div class="panel-section"><div class="panel-section-title">👥 Viajeros</div>
                <button class="btn btn-xs btn-ghost" onclick="openEditViajeros('${l.id}')">➕ Agregar viajeros</button>
            </div>
            `)}
            <div class="panel-section"><div class="panel-section-title">Viaje</div>
                <div class="info-row"><span class="info-label">Destino</span><span class="info-val">${window.escHtml(l.destination) || 'Sin definir'}</span></div>
                <div class="info-row"><span class="info-label">Tipo</span><span class="info-val">${TYPE_LABELS[l.type] || 'Otro'}</span></div>
                <div class="info-row"><span class="info-label">Fecha viaje</span><span class="info-val">${window.fmtDate(l.travelDate)}</span></div>
                <div class="info-row"><span class="info-label">Fecha fin</span><span class="info-val">${window.fmtDate(l.travelEnd)}</span></div>
                ${l.platform ? `<div class="info-row"><span class="info-label">Operador</span><span class="info-val" style="color:var(--purple-light)">${window.escHtml(l.platform)}</span></div>` : ''}
                ${l.createdAt ? `<div class="info-row"><span class="info-label">Registrado</span><span class="info-val" style="color:var(--text-3)">${window.fmtDate(l.createdAt)}${l.source === 'Formulario Web' ? ' (Formulario)' : l.source ? ` (${window.escHtml(l.source)})` : ''}</span></div>` : ''}
            </div>
            ${renderConfirmationsPanel(l)}
            ${renderHotelsPanel(l)}
            ${renderParkEntriesPanel(l)}
            ${renderCruisesPanel(l)}
            <div class="panel-section"><div class="panel-section-title">Financiero</div>
                <div class="info-row"><span class="info-label">Valor Venta</span><span class="info-val" style="color:var(--green)">${window.fmt(l.totalVenta)}</span></div>
                <div class="info-row"><span class="info-label">Comisión Total</span><span class="info-val">${window.fmt(l.commission)}</span></div>
                <div class="info-row"><span class="info-label">Comisión M2M</span><span class="info-val" style="color:var(--green)">${window.fmt(l.commission70)}</span></div>
            </div>
            <div class="panel-section"><div class="panel-section-title">💰 Estado de Pagos</div>
                <div class="info-row"><span class="info-label">Abono Requerido</span><span class="info-val">${window.fmt(l.abono || window.calcularAbonoEsperado(l.type, l.totalVenta))}</span></div>
                <div class="info-row" style="align-items:center;">
                    <span class="info-label" style="display:flex;align-items:center;gap:8px;">
                        <input type="checkbox" id="panelCheckAbono" ${(l.abonado || 0) >= (l.abono || window.calcularAbonoEsperado(l.type, l.totalVenta)) ? 'checked' : ''} onchange="toggleAbonoFromPanel('${l.id}')" style="width:16px;height:16px;cursor:pointer;">
                        Abonado
                    </span>
                    <span class="info-val" style="color:${(l.abonado || 0) > 0 ? 'var(--green)' : 'var(--yellow)'}">${(l.abonado || 0) > 0 ? window.fmt(l.abonado) : 'Pendiente'}</span>
                </div>
                ${l.fechaAbono ? `<div class="info-row"><span class="info-label">Límite Abono</span><span class="info-val" style="color:${(() => { const d = Math.ceil((new Date(l.fechaAbono) - new Date()) / 86400000); return d <= 7 && d >= 0 ? 'var(--red)' : d < 0 ? 'var(--green)' : 'var(--text-1)' })()}">${window.fmtDate(l.fechaAbono)}${(() => { const d = Math.ceil((new Date(l.fechaAbono) - new Date()) / 86400000); return d >= 0 ? ` (${d}d)` : ' ✓' })()}</span></div>` : ''}
                <div class="info-row"><span class="info-label">Saldo Pendiente</span><span class="info-val" style="color:${((l.totalVenta || 0) - (l.abonado || 0)) > 0 ? 'var(--yellow)' : 'var(--green)'}">${window.fmt((l.totalVenta || 0) - (l.abonado || 0))}</span></div>
                <div class="info-row" style="align-items:center;">
                    <span class="info-label" style="display:flex;align-items:center;gap:8px;">
                        <input type="checkbox" id="panelCheckPagoTotal" ${(l.abonado || 0) >= (l.totalVenta || 0) && (l.totalVenta || 0) > 0 ? 'checked' : ''} onchange="togglePagoTotalFromPanel('${l.id}')" style="width:16px;height:16px;cursor:pointer;">
                        Pago Completo
                    </span>
                    <span class="info-val" style="color:${(l.abonado || 0) >= (l.totalVenta || 0) && (l.totalVenta || 0) > 0 ? 'var(--green)' : 'var(--text-2)'}">${(l.abonado || 0) >= (l.totalVenta || 0) && (l.totalVenta || 0) > 0 ? '✓ Pagado' : ''}</span>
                </div>
                ${l.fechaPagoFinal ? `<div class="info-row"><span class="info-label">Límite Pago Final</span><span class="info-val" style="color:${(() => { const d = Math.ceil((new Date(l.fechaPagoFinal) - new Date()) / 86400000); return d <= 30 && d >= 0 ? 'var(--red)' : d < 0 ? 'var(--green)' : 'var(--text-1)' })()}">${window.fmtDate(l.fechaPagoFinal)}${(() => { const d = Math.ceil((new Date(l.fechaPagoFinal) - new Date()) / 86400000); return d >= 0 ? ` (${d}d)` : ' ✓' })()}</span></div>` : ''}
                <div class="info-row"><span class="info-label">Progreso</span><span class="info-val">${l.progress}%</span></div>
            </div>
            ${c && c.trips.length > 1 ? `<div class="panel-section"><div class="panel-section-title">Otros viajes (${c.trips.length - 1})</div>${c.trips.filter(x => x.id !== id).map(x => `<div class="info-row"><span class="info-label">${window.escHtml(x.destination)}</span><span class="info-val">${window.fmtDate(x.travelDate)} — ${window.fmt(x.totalVenta)}</span></div>`).join('')}</div>` : ''}
            <div class="panel-section" style="display:flex;gap:8px;flex-wrap:wrap;">
                <button class="btn btn-secondary btn-sm" onclick="openTripView('${window.escHtml(l.clientKey)}', '${l.travelDate}')" style="flex:1;">🗺️ Ver Viaje Completo</button>
                <button class="btn btn-secondary btn-sm" onclick="openClient('${window.escHtml(l.clientKey)}')" style="flex:1;">👤 Ver Cliente</button>
            </div>
            <div class="panel-section" style="text-align:center;">
                <button class="btn btn-ghost btn-sm" onclick="showHistorialModal('${window.escHtml(l.id)}')" style="width:100%;color:var(--text-2);">📋 Historial de Cambios${(l.formData?._historial?.length || 0) > 0 ? ` (${l.formData._historial.length})` : ''}</button>
            </div>
            ${window.renderGuideSection(l)}
            ${window.renderItinerarySection?.(l) || ''}
            ${window.renderDashboardSection?.(l) || ''}
            ${window.renderWhatsAppSection?.(l) || ''}
            ${(l.type === 'crucero' || l.type === 'parques_crucero') ? `<div class="panel-section" style="text-align:center;display:flex;gap:8px;"><button class="btn btn-secondary btn-sm" onclick="showGuideModal('${l.id}')" style="flex:1;">📄 Guía Crucero</button><button class="btn btn-secondary btn-sm" onclick="downloadWelcome('${l.id}')" style="flex:1;">🚢 Welcome</button></div>` : ''}
            ${window.renderFormDataPanel(l)}
            ${window.renderSolicitudCrucero(id)}
            ${window.renderCotizaciones(id)}
            ${window.renderTareasEnPanel(id)}
            ${window.renderComentarios(id)}
        `
    } else {
        // ========== MODO COMPACTO ==========
        document.getElementById('panelBody').innerHTML = `
            <div class="panel-section">
                <div class="stage-progress">${stageProgress}</div>
                <div style="text-align:center;font-size:11px;color:var(--text-2);margin-top:6px;">${stageName}</div>
            </div>

            <div style="background:var(--bg-2);border-radius:var(--radius);padding:14px;margin-bottom:12px;border-left:3px solid ${stageColor};">
                <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;">
                    <span style="font-weight:600;font-size:14px;">${l.destination || 'Sin destino'}</span>
                    <span class="card-tag ${l.type}" style="font-size:10px;">${TYPE_LABELS[l.type] || 'Otro'}</span>
                </div>
                <div style="font-size:12px;color:var(--text-2);margin-bottom:6px;">
                    📅 ${window.fmtDate(l.travelDate)}${l.travelEnd ? ' → ' + window.fmtDate(l.travelEnd) : ''}
                </div>
                ${(() => {
                    if (l.type === 'crucero' || l.type === 'parques_crucero') {
                        const cruises = l.cruises || []
                        if (cruises.length > 0) {
                            return cruises.map(cr => {
                                const isPaid = cr.balance != null ? cr.balance <= 0 : false
                                const shipLine = window.escHtml(cr.ship || cr.line || 'Crucero') + (cr.departurePort ? ' — ' + window.escHtml(cr.departurePort) : '')
                                const resNum = cr.reservationNum ? ' <span style="font-size:10px;color:var(--cyan);font-family:monospace;">#' + window.escHtml(cr.reservationNum) + '</span>' : ''
                                const titularLine = cr.titular && cruises.length > 1 ? '<div style="font-size:10px;color:var(--text-3);">Fam. ' + window.escHtml(cr.titular.split(' ').slice(0, 2).join(' ')) + '</div>' : ''
                                const payLine = cr.totalVenta && cruises.length > 1 ? '<div style="font-size:10px;margin-top:2px;display:flex;justify-content:space-between;"><span style="color:var(--green);">' + window.fmt(cr.totalVenta) + '</span><span style="color:' + (isPaid ? 'var(--green)' : 'var(--yellow)') + ';">' + (isPaid ? 'Pagado' : 'Saldo: ' + window.fmt(cr.balance || 0)) + '</span></div>' : ''
                                return '<div style="font-size:12px;color:#0077b6;margin-bottom:6px;padding:6px 8px;background:var(--bg-2);border-left:3px solid #0077b6;border-radius:4px;">' + shipLine + resNum + titularLine + payLine + '</div>'
                            }).join('')
                        }
                        return ''
                    }
                    const vp = (l.parkEntries || []).filter(p => p.park || (parseInt(p.days) > 0))
                    if (vp.length) return '<div style="font-size:12px;color:var(--purple-light);margin-bottom:6px;">🎢 ' + vp.map(p => (p.park || 'Parque') + ' ' + (p.days || 0) + 'd').join(' + ') + '</div>'
                    if (l.diasParque || t?.diasParque) return '<div style="font-size:12px;color:var(--purple-light);margin-bottom:6px;">🎢 ' + (l.tipoParque || t?.tipoParque || '') + ' ' + (l.diasParque || t?.diasParque) + ' días</div>'
                    return ''
                })()}
                ${_renderViajerosCompact(l)}
                ${l.reservationNum && !(l.cruises?.length > 0) ? `<div style="font-size:11px;color:var(--cyan);margin-bottom:6px;font-family:monospace;">📋 #${window.escHtml(l.reservationNum)}</div>` : ''}
                ${l.createdAt ? `<div style="font-size:10px;color:var(--text-3);margin-bottom:6px;">📝 Registrado: ${window.fmtDate(l.createdAt)}${l.source === 'Formulario Web' ? ' (Formulario)' : ''}</div>` : ''}

                <div style="display:flex;justify-content:space-between;align-items:center;padding-top:8px;border-top:1px solid var(--border);">
                    <span style="font-size:16px;font-weight:600;color:var(--green);">${window.fmt(l.totalVenta)}</span>
                    <span style="font-size:12px;padding:4px 10px;border-radius:12px;background:${isPagado ? 'rgba(16,185,129,0.15)' : (tieneAbono ? 'rgba(245,158,11,0.15)' : 'rgba(239,68,68,0.15)')};color:${isPagado ? 'var(--green)' : (tieneAbono ? 'var(--yellow)' : 'var(--red)')};">
                        ${isPagado ? '✓ Pagado' : (tieneAbono ? `Abono: ${window.fmt(l.abonado)}` : 'Pendiente')}
                    </span>
                </div>
                ${fechaAbonoWarning ? `<div style="font-size:11px;color:var(--red);margin-top:6px;">${fechaAbonoWarning}</div>` : ''}
            </div>

            <div class="panel-section">
                <div class="panel-section-title">Responsable</div>
                <select class="inline-select" onchange="changeResponsableFromPanel('${l.id}', this.value)" ${isHistorico ? 'disabled' : ''}>${respOptions}</select>
            </div>

            <div class="panel-section">
                <div style="display:flex;gap:6px;margin-bottom:8px;">
                    <div style="flex:1;text-align:center;padding:8px;background:var(--bg-2);border-radius:var(--radius);">
                        <div style="font-size:10px;color:var(--text-3);margin-bottom:2px;">Comisión</div>
                        <div style="font-size:13px;font-weight:600;">${window.fmt(l.commission)}</div>
                    </div>
                    <div style="flex:1;text-align:center;padding:8px;background:var(--bg-2);border-radius:var(--radius);">
                        <div style="font-size:10px;color:var(--text-3);margin-bottom:2px;">M2M</div>
                        <div style="font-size:13px;font-weight:600;color:var(--green);">${window.fmt(l.commission70)}</div>
                    </div>
                    <div style="flex:1;text-align:center;padding:8px;background:var(--bg-2);border-radius:var(--radius);">
                        <div style="font-size:10px;color:var(--text-3);margin-bottom:2px;">Saldo</div>
                        <div style="font-size:13px;font-weight:600;color:${saldoPendiente > 0 ? 'var(--yellow)' : 'var(--green)'};">${window.fmt(saldoPendiente)}</div>
                    </div>
                </div>
            </div>

            <div class="panel-section" style="display:flex;gap:8px;flex-wrap:wrap;">
                <button class="btn btn-secondary btn-sm" onclick="openTripView('${window.escHtml(l.clientKey)}', '${l.travelDate}')" style="flex:1;">🗺️ Ver Viaje</button>
                <button class="btn btn-secondary btn-sm" onclick="openClient('${window.escHtml(l.clientKey)}')" style="flex:1;">👤 Cliente</button>
            </div>
            ${window.renderGuideSection(l)}
            ${window.renderItinerarySection?.(l) || ''}
            ${window.renderDashboardSection?.(l) || ''}
            ${window.renderWhatsAppSection?.(l) || ''}
            ${(l.type === 'crucero' || l.type === 'parques_crucero') ? `<div class="panel-section" style="text-align:center;display:flex;gap:8px;"><button class="btn btn-secondary btn-sm" onclick="showGuideModal('${l.id}')" style="flex:1;">📄 Guía Crucero</button><button class="btn btn-secondary btn-sm" onclick="downloadWelcome('${l.id}')" style="flex:1;">🚢 Welcome</button></div>` : ''}
            ${!isHistorico ? `
            <div class="panel-section" style="display:flex;gap:8px;flex-wrap:wrap;">
                <button class="btn btn-sm" onclick="toggleAbonoFromPanel('${l.id}')" style="flex:1;${tieneAbono ? 'opacity:0.5;' : ''}">${tieneAbono ? '✓ Abonado' : '💳 Marcar Abono'}</button>
                <button class="btn btn-sm btn-primary" onclick="togglePagoTotalFromPanel('${l.id}')" style="flex:1;${isPagado ? 'opacity:0.5;' : ''}">${isPagado ? '✓ Pagado' : '💰 Pago Completo'}</button>
            </div>
            ` : ''}
            <div class="panel-section" style="text-align:center;">
                <button class="btn btn-ghost btn-sm" onclick="showHistorialModal('${l.id}')" style="width:100%;color:var(--text-2);">📋 Historial${(l.formData?._historial?.length || 0) > 0 ? ` (${l.formData._historial.length})` : ''}</button>
            </div>

            <!-- Botón Ver más -->
            <div style="text-align:center;margin:8px 0;">
                <button class="btn btn-ghost btn-sm" onclick="togglePanelDetails()" id="btnToggleDetails" style="width:100%;color:var(--text-3);">
                    <span id="toggleDetailsIcon">▼</span> Ver más detalles
                </button>
            </div>

            <!-- Secciones colapsables -->
            <div id="panelDetailsExpanded" style="display:none;">
                <div class="panel-section"><div class="panel-section-title">👤 Personas</div>
                    <div class="info-row"><span class="info-label">Titular</span><span class="info-val">${window.escHtml(l.titular)}</span></div>
                    ${l.contacto && l.contacto !== l.titular ? `<div class="info-row"><span class="info-label">Contacto</span><span class="info-val">${window.escHtml(l.contacto)}</span></div>` : ''}
                    <div class="info-row"><span class="info-label">Teléfono</span><span class="info-val">${window.escHtml(l.phone) || 'Sin registrar'}${(() => { const waPhone = (l.phone || '').replace(/\D/g, ''); return waPhone ? ` <a href="https://wa.me/${waPhone}" target="_blank" rel="noopener" title="Abrir WhatsApp" style="color:#1FA855;text-decoration:none;"><svg width="14" height="14" viewBox="0 0 24 24" fill="#1FA855" style="vertical-align:middle;"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg></a>` : ''; })()}</span></div>
                    <div class="info-row"><span class="info-label">Email</span><span class="info-val">${window.escHtml(l.email) || 'Sin registrar'}</span></div>
                    ${c?.referido ? `<div class="info-row"><span class="info-label">Referido por</span><span class="info-val">${window.escHtml(c.referido)}</span></div>` : ''}
                    <div class="info-row"><span class="info-label">Alertas</span><span class="info-val">${{'whatsapp':'📱 WhatsApp','email':'📧 Email','ambos':'📱📧 Ambos','ninguno':'🔕 Ninguno'}[c?.canalAlerta] || '📱 WhatsApp'}</span></div>
                </div>
                ${(l.grupoViajeros || t?.grupoViajeros) ? `
                <div class="panel-section">
                    <div class="panel-section-title" style="display:flex;justify-content:space-between;align-items:center;">
                        <span>👥 Grupo de Viajeros (${(l.grupoViajeros || t?.grupoViajeros).length})</span>
                        <button class="btn btn-xs btn-ghost" onclick="openEditViajeros('${l.id}')" title="Editar viajeros">✏️</button>
                    </div>
                    ${(l.grupoViajeros || t?.grupoViajeros).map(v => `
                        <div class="info-row" style="padding:6px 0;border-bottom:1px solid var(--border);">
                            <span class="info-label" style="display:flex;align-items:center;gap:6px;">
                                ${v.esTitular ? '⭐' : '👤'} ${window.escHtml(v.nombre)}
                                ${v.esMenor ? '<span style="background:var(--purple);color:white;padding:1px 6px;border-radius:10px;font-size:10px;">M</span>' : ''}
                                ${v.fechaNacimiento ? '<span style="color:var(--text-3);font-size:10px;">🎂 ' + window.fmtDate(v.fechaNacimiento) + '</span>' : ''}
                            </span>
                            <span class="info-val">${v.edad ? v.edad + ' años' : (v.esMenor ? '' : 'Adulto')}</span>
                        </div>
                    `).join('')}
                </div>
                ` : ''}
                <div class="panel-section"><div class="panel-section-title">✈️ Viaje</div>
                    <div class="info-row"><span class="info-label">Destino</span><span class="info-val">${window.escHtml(l.destination) || 'Sin definir'}</span></div>
                    <div class="info-row"><span class="info-label">Tipo</span><span class="info-val">${TYPE_LABELS[l.type] || 'Otro'}</span></div>
                    <div class="info-row"><span class="info-label">Fecha viaje</span><span class="info-val">${window.fmtDate(l.travelDate)}</span></div>
                    <div class="info-row"><span class="info-label">Fecha fin</span><span class="info-val">${window.fmtDate(l.travelEnd)}</span></div>
                    ${l.platform ? `<div class="info-row"><span class="info-label">Operador</span><span class="info-val" style="color:var(--purple-light)">${window.escHtml(l.platform)}</span></div>` : ''}
                </div>
                ${renderHotelsPanel(l)}
                ${renderParkEntriesPanel(l)}
                <div class="panel-section"><div class="panel-section-title">💵 Financiero</div>
                    <div class="info-row"><span class="info-label">Valor Venta</span><span class="info-val" style="color:var(--green)">${window.fmt(l.totalVenta)}</span></div>
                    <div class="info-row"><span class="info-label">Comisión Total</span><span class="info-val">${window.fmt(l.commission)}</span></div>
                    <div class="info-row"><span class="info-label">Comisión M2M</span><span class="info-val" style="color:var(--green)">${window.fmt(l.commission70)}</span></div>
                </div>
                <div class="panel-section"><div class="panel-section-title">💰 Estado de Pagos</div>
                    <div class="info-row"><span class="info-label">Abono Requerido</span><span class="info-val">${window.fmt(l.abono || window.calcularAbonoEsperado(l.type, l.totalVenta))}</span></div>
                    <div class="info-row"><span class="info-label">Abonado</span><span class="info-val" style="color:${(l.abonado || 0) > 0 ? 'var(--green)' : 'var(--yellow)'}">${(l.abonado || 0) > 0 ? window.fmt(l.abonado) : 'Pendiente'}</span></div>
                    ${l.fechaAbono ? `<div class="info-row"><span class="info-label">Límite Abono</span><span class="info-val" style="color:${(() => { const d = Math.ceil((new Date(l.fechaAbono) - new Date()) / 86400000); return d <= 7 && d >= 0 ? 'var(--red)' : d < 0 ? 'var(--green)' : 'var(--text-1)' })()}">${window.fmtDate(l.fechaAbono)}${(() => { const d = Math.ceil((new Date(l.fechaAbono) - new Date()) / 86400000); return d >= 0 ? ` (${d}d)` : ' ✓' })()}</span></div>` : ''}
                    <div class="info-row"><span class="info-label">Saldo Pendiente</span><span class="info-val" style="color:${saldoPendiente > 0 ? 'var(--yellow)' : 'var(--green)'}">${window.fmt(saldoPendiente)}</span></div>
                    ${l.fechaPagoFinal ? `<div class="info-row"><span class="info-label">Límite Pago Final</span><span class="info-val" style="color:${(() => { const d = Math.ceil((new Date(l.fechaPagoFinal) - new Date()) / 86400000); return d <= 30 && d >= 0 ? 'var(--red)' : d < 0 ? 'var(--green)' : 'var(--text-1)' })()}">${window.fmtDate(l.fechaPagoFinal)}${(() => { const d = Math.ceil((new Date(l.fechaPagoFinal) - new Date()) / 86400000); return d >= 0 ? ` (${d}d)` : ' ✓' })()}</span></div>` : ''}
                </div>
                ${c && c.trips.length > 1 ? `<div class="panel-section"><div class="panel-section-title">📦 Otros viajes (${c.trips.length - 1})</div>${c.trips.filter(x => x.id !== id).map(x => `<div class="info-row"><span class="info-label">${x.destination}</span><span class="info-val">${window.fmtDate(x.travelDate)} — ${window.fmt(x.totalVenta)}</span></div>`).join('')}</div>` : ''}

                ${window.renderFormDataPanel(l)}
                ${window.renderSolicitudCrucero(id)}
                ${window.renderCotizaciones(id)}
                ${window.renderTareasEnPanel(id)}
                ${window.renderComentarios(id)}
            </div>
        `
    }
    document.getElementById('panel').classList.add('active')

    // Lazy-load WhatsApp messages on panel open
    const waSupaId = l._supabaseId || l.id
    if (waSupaId && typeof waSupaId === 'string' && waSupaId.length === 36 && !store.whatsappMessages[waSupaId]) {
        window.loadWhatsAppMessages?.(waSupaId)
    }
}

// ========== MULTI-HOTEL ROW BUILDER ==========
function addHotelRow(data = {}, container = null) {
    const c = container || document.getElementById('eHotelsContainer')
    const row = document.createElement('div')
    row.className = 'hotel-entry-row'
    row.style.cssText = 'background:var(--bg-2);padding:12px;border-radius:8px;margin-bottom:8px;'

    // Provider select (same operators as lead)
    const providers = ['', 'Disney', 'Disney Cruise Line', 'VAX', 'Expedia TAAP', 'Universal', 'Royal Caribbean', 'MSC Cruises']
    const isCustomProvider = data.provider && !providers.includes(data.provider)
    const providerVal = isCustomProvider ? '__otro__' : (data.provider || '')
    const providerOpts = providers.map(p => `<option value="${p}" ${providerVal === p ? 'selected' : ''}>${p || '-- Operador --'}</option>`).join('') +
        `<option value="__otro__" ${isCustomProvider ? 'selected' : ''}>Otro...</option>`

    row.innerHTML = `
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;">
            <span style="font-size:11px;font-weight:600;color:var(--text-3);text-transform:uppercase;">Hotel ${c.querySelectorAll('.hotel-entry-row').length + 1}</span>
            <button type="button" class="btn btn-xs btn-ghost" onclick="this.closest('.hotel-entry-row').remove()" style="color:var(--red);">✕ Quitar</button>
        </div>
        <div class="form-row-2">
            <div class="form-group"><label class="form-label">Hotel</label><input type="text" class="form-input" data-field="name" value="${window.escHtml(data.name || '')}" placeholder="Nombre del hotel"></div>
            <div class="form-group"><label class="form-label"># Reserva</label><input type="text" class="form-input" data-field="reservationNum" value="${window.escHtml(data.reservationNum || '')}" placeholder="Confirmación"></div>
        </div>
        <div class="form-row-2">
            <div class="form-group"><label class="form-label">Operador</label>
                <select class="form-input" data-field="provider" onchange="const o=this.closest('.hotel-entry-row').querySelector('[data-field=providerOtro]');o.classList.toggle('hidden',this.value!=='__otro__')">${providerOpts}</select>
                <input type="text" class="form-input ${isCustomProvider ? '' : 'hidden'}" data-field="providerOtro" value="${isCustomProvider ? window.escHtml(data.provider) : ''}" placeholder="Nombre del operador" style="margin-top:6px;">
            </div>
            <div class="form-group"><label class="form-label">Costo (USD)</label><input type="number" class="form-input" data-field="cost" value="${data.cost != null ? data.cost : ''}" min="0" step="0.01" placeholder="0"></div>
        </div>
        <div class="form-row-2">
            <div class="form-group"><label class="form-label">Check-in</label><input type="date" class="form-input" data-field="checkIn" value="${data.checkIn ? String(data.checkIn).substring(0, 10) : ''}"></div>
            <div class="form-group"><label class="form-label">Check-out</label><input type="date" class="form-input" data-field="checkOut" value="${data.checkOut ? String(data.checkOut).substring(0, 10) : ''}"></div>
        </div>
        <div class="form-row-3" style="grid-template-columns:1fr 1fr 1fr;">
            <div class="form-group"><label class="form-label">Habitaciones</label><input type="number" class="form-input" data-field="rooms" value="${data.rooms != null ? data.rooms : ''}" min="0" max="20" placeholder="0" onchange="updateHotelRoomDistribution(this)"></div>
            <div class="form-group"><label class="form-label">Tipo</label><input type="text" class="form-input" data-field="type" value="${window.escHtml(data.type || '')}" placeholder="Ej: Deluxe, Value"></div>
            <div class="form-group" style="margin-bottom:0;"><label class="form-label">Notas</label><input type="text" class="form-input" data-field="notes" value="${window.escHtml(data.notes || '')}" placeholder="Huéspedes, solicitudes..."></div>
        </div>
        <div class="hotel-room-distribution"></div>
    `
    c.appendChild(row)
    // Initialize distribution if rooms > 1 or existing distribution data
    if ((data.rooms || 0) > 1 || (data.distribucion && data.distribucion.length > 0)) {
        _renderHotelDistribution(row, data.rooms || data.distribucion?.length || 0, data.distribucion || [], data.juntosSiPosible || false)
    }
}

// ========== MULTI-PARK ROW BUILDER ==========
function addParkEntryRow(data = {}, container = null) {
    const c = container || document.getElementById('eParkEntriesContainer')
    const row = document.createElement('div')
    row.className = 'park-entry-row'
    row.style.cssText = 'background:var(--bg-2);padding:12px;border-radius:8px;margin-bottom:8px;'

    const parkOptions = ['', 'Disney World', 'Universal Orlando', 'Disneyland', 'SeaWorld', 'Legoland']
    const isCustom = data.park && !parkOptions.includes(data.park)
    const selectVal = isCustom ? '__otro__' : (data.park || '')
    const optionsHtml = parkOptions.map(p => `<option value="${p}" ${selectVal === p ? 'selected' : ''}>${p || '-- Ninguno --'}</option>`).join('') +
        `<option value="__otro__" ${isCustom ? 'selected' : ''}>Otro...</option>`

    row.innerHTML = `
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;">
            <span style="font-size:11px;font-weight:600;color:var(--text-3);text-transform:uppercase;">Parque ${c.querySelectorAll('.park-entry-row').length + 1}</span>
            <button type="button" class="btn btn-xs btn-ghost" onclick="this.closest('.park-entry-row').remove()" style="color:var(--red);">✕ Quitar</button>
        </div>
        <div class="form-row-3">
            <div class="form-group"><label class="form-label">Parques</label>
                <select class="form-input" data-field="park" onchange="updateParkAddons(this)">${optionsHtml}</select>
                <input type="text" class="form-input ${isCustom ? '' : 'hidden'}" data-field="parkOtro" value="${isCustom ? window.escHtml(data.park) : ''}" placeholder="Nombre del parque" style="margin-top:6px;">
            </div>
            <div class="form-group"><label class="form-label">Días</label><input type="number" class="form-input" data-field="days" value="${data.days != null ? data.days : ''}" min="0" max="30" placeholder="0"></div>
            <div class="form-group"><label class="form-label">Tipo ticket</label><input type="text" class="form-input" data-field="ticketType" value="${window.escHtml(data.ticketType || '')}" placeholder="Ej: 6-Day Base"></div>
        </div>
        <div class="form-row-3" style="grid-template-columns:1fr 1fr 1fr;">
            <div class="form-group"><label class="form-label">Válido desde</label><input type="date" class="form-input" data-field="validFrom" value="${data.validFrom ? String(data.validFrom).substring(0, 10) : ''}"></div>
            <div class="form-group"><label class="form-label">Válido hasta</label><input type="date" class="form-input" data-field="validTo" value="${data.validTo ? String(data.validTo).substring(0, 10) : ''}"></div>
            <div class="form-group"><label class="form-label"># Reserva</label><input type="text" class="form-input" data-field="reservationNum" value="${window.escHtml(data.reservationNum || '')}" placeholder="Confirmación"></div>
        </div>
        <div style="margin-top:8px;padding-top:8px;border-top:1px dashed var(--border);">
            <div style="display:flex;gap:16px;align-items:flex-end;">
                <div style="text-align:center;">
                    <label class="form-label" style="font-size:11px;margin-bottom:4px;">Tickets adulto <span style="color:var(--text-3);">(10+)</span></label>
                    <div style="display:flex;align-items:center;gap:6px;">
                        <button type="button" class="btn btn-xs btn-ghost" onclick="stepParkTickets(this,'adultos',-1)" style="width:24px;height:24px;border-radius:50%;border:1px solid var(--border);font-size:14px;line-height:1;">−</button>
                        <input type="number" class="form-input" data-field="adultos" value="${data.adultos != null ? data.adultos : ''}" min="0" max="30" style="width:44px;text-align:center;padding:3px;font-size:12px;" placeholder="0">
                        <button type="button" class="btn btn-xs btn-ghost" onclick="stepParkTickets(this,'adultos',1)" style="width:24px;height:24px;border-radius:50%;border:1px solid var(--border);font-size:14px;line-height:1;">+</button>
                    </div>
                </div>
                <div style="text-align:center;">
                    <label class="form-label" style="font-size:11px;margin-bottom:4px;">Tickets menor <span style="color:var(--text-3);">(<10)</span></label>
                    <div style="display:flex;align-items:center;gap:6px;">
                        <button type="button" class="btn btn-xs btn-ghost" onclick="stepParkTickets(this,'menores',-1)" style="width:24px;height:24px;border-radius:50%;border:1px solid var(--border);font-size:14px;line-height:1;">−</button>
                        <input type="number" class="form-input" data-field="menores" value="${data.menores != null ? data.menores : ''}" min="0" max="20" style="width:44px;text-align:center;padding:3px;font-size:12px;" placeholder="0">
                        <button type="button" class="btn btn-xs btn-ghost" onclick="stepParkTickets(this,'menores',1)" style="width:24px;height:24px;border-radius:50%;border:1px solid var(--border);font-size:14px;line-height:1;">+</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="park-addons" style="display:flex;gap:16px;align-items:center;flex-wrap:wrap;margin-top:4px;">
            <div class="disney-addons" style="display:none;gap:12px;">
                <label style="display:flex;align-items:center;gap:6px;cursor:pointer;font-size:12px;">
                    <input type="checkbox" data-field="parkHopper" ${data.parkHopper ? 'checked' : ''} style="width:15px;height:15px;">
                    <span>🎫 Park Hopper</span>
                </label>
                <div style="display:flex;align-items:center;gap:6px;font-size:12px;">
                    <span>🍽️</span>
                    <select data-field="diningPlan" style="font-size:12px;padding:2px 6px;border:1px solid var(--border);border-radius:4px;background:var(--bg-2);color:var(--text-1);">
                        <option value="" ${!data.diningPlan ? 'selected' : ''}>Sin Dining Plan</option>
                        <option value="quick_service" ${data.diningPlan === 'quick_service' ? 'selected' : ''}>Quick Service</option>
                        <option value="standard" ${data.diningPlan === 'standard' || data.diningPlan === true || data.diningPlan === 'deluxe' ? 'selected' : ''}>Disney Dining Plan</option>
                    </select>
                </div>
                <label style="display:flex;align-items:center;gap:6px;cursor:pointer;font-size:12px;">
                    <input type="checkbox" data-field="lightningLane" ${data.lightningLane ? 'checked' : ''} style="width:15px;height:15px;">
                    <span>⚡ Lightning Lane</span>
                </label>
            </div>
            <div class="universal-addons" style="display:none;gap:12px;">
                <label style="display:flex;align-items:center;gap:6px;cursor:pointer;font-size:12px;">
                    <input type="checkbox" data-field="expressPass" ${data.expressPass ? 'checked' : ''} style="width:15px;height:15px;">
                    <span>🎢 Express Pass</span>
                </label>
            </div>
            <div class="form-group" style="margin-bottom:0;flex:1;min-width:100px;"><label class="form-label">Costo (USD)</label><input type="number" class="form-input" data-field="cost" value="${data.cost != null ? data.cost : ''}" min="0" step="0.01" placeholder="0"></div>
        </div>
    `
    // Trigger addon visibility based on initial park value
    const parkSelect = row.querySelector('[data-field="park"]')
    if (parkSelect) _updateParkAddonsForRow(row, parkSelect.value)
    c.appendChild(row)
}

// ========== PARK ADDON VISIBILITY ==========
function _updateParkAddonsForRow(row, parkVal) {
    const otro = row.querySelector('[data-field=parkOtro]')
    if (otro) otro.classList.toggle('hidden', parkVal !== '__otro__')
    const isDisney = ['Disney World', 'Disneyland'].includes(parkVal)
    const isUniversal = parkVal === 'Universal Orlando'
    const disneyAddons = row.querySelector('.disney-addons')
    const universalAddons = row.querySelector('.universal-addons')
    if (disneyAddons) disneyAddons.style.display = isDisney ? 'flex' : 'none'
    if (universalAddons) universalAddons.style.display = isUniversal ? 'flex' : 'none'
}

function updateParkAddons(selectEl) {
    const row = selectEl.closest('.park-entry-row')
    if (row) _updateParkAddonsForRow(row, selectEl.value)
}

// ========== HOTEL ROOM DISTRIBUTION ==========
function updateHotelRoomDistribution(input) {
    const row = input.closest('.hotel-entry-row')
    if (!row) return
    const rooms = parseInt(input.value) || 0
    _renderHotelDistribution(row, rooms)
}

function _renderHotelDistribution(row, rooms, existingDist, juntosParam) {
    const container = row.querySelector('.hotel-room-distribution')
    if (!container) return
    if (rooms <= 1) {
        container.style.display = 'none'
        container.innerHTML = ''
        return
    }
    // Preserve existing DOM values if no explicit data passed
    const existing = existingDist || []
    const isJuntos = juntosParam !== undefined ? juntosParam : (container.querySelector('[data-field="juntosSiPosible"]')?.checked || false)
    if (!existingDist) {
        container.querySelectorAll('.room-dist-row').forEach(r => {
            existing.push({
                adultos: parseInt(r.querySelector('[data-field="distAdultos"]')?.value) || 0,
                menores: parseInt(r.querySelector('[data-field="distMenores"]')?.value) || 0,
                edadesMenores: [...r.querySelectorAll('[data-field="distAge"]')].map(i => parseInt(i.value)).filter(n => !isNaN(n))
            })
        })
    }
    container.style.display = 'block'
    let html = `<label style="display:flex;align-items:center;gap:6px;margin-top:4px;margin-bottom:8px;font-size:11px;color:var(--text-2);cursor:pointer;">
        <input type="checkbox" data-field="juntosSiPosible" ${isJuntos ? 'checked' : ''} style="accent-color:var(--purple);width:14px;height:14px;">
        Prefieren estar todos juntos si es posible
    </label>`
    html += '<div style="font-size:11px;font-weight:600;color:var(--text-3);margin-bottom:6px;">DISTRIBUCIÓN POR HABITACIÓN</div>'
    for (let i = 0; i < rooms; i++) {
        const prev = existing[i] || {}
        const ages = prev.edadesMenores || []
        const agesHtml = ages.map((age, j) =>
            `<div style="text-align:center;"><div style="font-size:9px;color:var(--text-3);">M${j + 1}</div><input type="number" class="form-input" data-field="distAge" value="${age}" min="0" max="17" style="width:40px;text-align:center;padding:3px;font-size:11px;" placeholder="?"></div>`
        ).join('')
        html += `
            <div class="room-dist-row" style="display:flex;gap:8px;align-items:flex-start;padding:6px 8px;background:var(--bg-1);border-radius:6px;margin-bottom:4px;border-left:2px solid var(--cyan);">
                <span style="font-size:10px;font-weight:600;color:var(--text-3);min-width:40px;padding-top:4px;">Hab ${i + 1}</span>
                <div style="text-align:center;"><div style="font-size:9px;color:var(--text-3);">Adultos</div><input type="number" class="form-input" data-field="distAdultos" value="${prev.adultos || ''}" min="0" max="10" style="width:44px;text-align:center;padding:3px;font-size:11px;" placeholder="0"></div>
                <div style="text-align:center;"><div style="font-size:9px;color:var(--text-3);">Menores</div><input type="number" class="form-input" data-field="distMenores" value="${prev.menores || ''}" min="0" max="10" style="width:44px;text-align:center;padding:3px;font-size:11px;" placeholder="0" onchange="updateHotelRoomAges(this)"></div>
                <div class="room-dist-ages" style="display:flex;gap:4px;flex-wrap:wrap;align-items:flex-end;">${agesHtml}</div>
            </div>
        `
    }
    container.innerHTML = html
}

function updateHotelRoomAges(input) {
    const distRow = input.closest('.room-dist-row')
    if (!distRow) return
    const count = parseInt(input.value) || 0
    const container = distRow.querySelector('.room-dist-ages')
    if (!container) return
    const existing = [...container.querySelectorAll('input')].map(i => i.value)
    let html = ''
    for (let i = 0; i < count; i++) {
        const prevVal = existing[i] || ''
        html += `<div style="text-align:center;"><div style="font-size:9px;color:var(--text-3);">M${i + 1}</div><input type="number" class="form-input" data-field="distAge" value="${prevVal}" min="0" max="17" style="width:40px;text-align:center;padding:3px;font-size:11px;" placeholder="?"></div>`
    }
    container.innerHTML = html
}

// ========== COLLECTORS ==========
function collectHotelsFromForm() {
    const rows = document.querySelectorAll('#eHotelsContainer .hotel-entry-row')
    const hotels = []
    rows.forEach(row => {
        const get = (f) => row.querySelector(`[data-field="${f}"]`)
        const providerSelect = get('provider')?.value
        const providerOtro = get('providerOtro')?.value?.trim()
        const provider = providerSelect === '__otro__' ? providerOtro : (providerSelect || '')
        const _int = (v) => { const n = parseInt(v); return isNaN(n) ? null : n }
        const _float = (v) => { const n = parseFloat(v); return isNaN(n) ? null : n }
        // Collect room distribution
        const distRows = row.querySelectorAll('.room-dist-row')
        const distribucion = []
        distRows.forEach(dr => {
            const a = parseInt(dr.querySelector('[data-field="distAdultos"]')?.value) || 0
            const m = parseInt(dr.querySelector('[data-field="distMenores"]')?.value) || 0
            const ages = [...dr.querySelectorAll('[data-field="distAge"]')].map(i => parseInt(i.value)).filter(n => !isNaN(n))
            distribucion.push({ adultos: a, menores: m, edadesMenores: ages })
        })
        const entry = {
            name: get('name')?.value?.trim() || '',
            reservationNum: get('reservationNum')?.value?.trim() || '',
            provider,
            checkIn: get('checkIn')?.value || null,
            checkOut: get('checkOut')?.value || null,
            rooms: _int(get('rooms')?.value),
            type: get('type')?.value?.trim() || '',
            cost: _float(get('cost')?.value),
            notes: get('notes')?.value?.trim() || '',
            distribucion: distribucion.length > 0 ? distribucion : undefined,
            juntosSiPosible: get('juntosSiPosible')?.checked || false,
        }
        if (entry.name) hotels.push(entry)
    })
    return window.sortByDate(hotels, 'checkIn')
}

function collectParkEntriesFromForm() {
    const rows = document.querySelectorAll('#eParkEntriesContainer .park-entry-row')
    const entries = []
    rows.forEach(row => {
        const get = (f) => row.querySelector(`[data-field="${f}"]`)
        const parkSelect = get('park')?.value
        const parkOtro = get('parkOtro')?.value?.trim()
        const park = parkSelect === '__otro__' ? parkOtro : (parkSelect || '')
        const _int = (v) => { const n = parseInt(v); return isNaN(n) ? null : n }
        const _float = (v) => { const n = parseFloat(v); return isNaN(n) ? null : n }
        const entry = {
            park,
            days: _int(get('days')?.value),
            ticketType: get('ticketType')?.value?.trim() || '',
            validFrom: get('validFrom')?.value || null,
            validTo: get('validTo')?.value || null,
            reservationNum: get('reservationNum')?.value?.trim() || '',
            adultos: _int(get('adultos')?.value),
            menores: _int(get('menores')?.value),
            parkHopper: get('parkHopper')?.checked || false,
            diningPlan: get('diningPlan')?.value || '',
            lightningLane: get('lightningLane')?.checked || false,
            expressPass: get('expressPass')?.checked || false,
            cost: _float(get('cost')?.value),
        }
        if (entry.park || entry.days) entries.push(entry)
    })
    return window.sortByDate(entries, 'validFrom')
}

// ========== PANEL DISPLAY RENDERERS ==========
function renderHotelsPanel(lead) {
    const hotels = lead.hotels || []
    if (hotels.length === 0) return ''
    const totalCost = hotels.reduce((s, h) => s + (h.cost || 0), 0)
    const rows = hotels.map(h => `
        <div style="background:var(--bg-2);padding:10px;border-radius:8px;margin-bottom:6px;border-left:3px solid var(--cyan);">
            <div style="display:flex;justify-content:space-between;align-items:center;">
                <span style="font-weight:600;font-size:13px;">${window.escHtml(h.name)}</span>
                ${h.reservationNum ? `<span style="font-size:11px;color:var(--text-3);">#${window.escHtml(h.reservationNum)}</span>` : ''}
            </div>
            ${h.checkIn || h.checkOut ? `<div style="font-size:11px;color:var(--text-2);margin-top:4px;">📅 ${window.fmtDate(h.checkIn) || '?'} → ${window.fmtDate(h.checkOut) || '?'}</div>` : ''}
            <div style="display:flex;gap:12px;font-size:11px;color:var(--text-3);margin-top:4px;">
                ${h.provider ? `<span style="color:var(--purple-light);">${window.escHtml(h.provider)}</span>` : ''}
                ${h.rooms ? `<span>🛏️ ${h.rooms} hab.</span>` : ''}
                ${h.type ? `<span>${window.escHtml(h.type)}</span>` : ''}
                ${h.cost ? `<span style="color:var(--green);">${window.fmt(h.cost)}</span>` : ''}
            </div>
            ${h.notes ? `<div style="font-size:11px;color:var(--text-3);margin-top:4px;font-style:italic;">${window.escHtml(h.notes)}</div>` : ''}
            ${h.juntosSiPosible && (h.rooms || 0) > 1 ? `<div style="font-size:11px;color:var(--purple-light);margin-top:4px;">Prefieren estar todos juntos</div>` : ''}
            ${h.distribucion && h.distribucion.length > 0 ? `<div style="margin-top:6px;padding-top:6px;border-top:1px dashed var(--border);font-size:11px;color:var(--text-2);">${h.distribucion.map((d, i) => `<span style="margin-right:8px;">Hab ${i + 1}: ${d.adultos || 0}A${d.menores ? ` + ${d.menores}M` + ((d.edadesMenores || []).length ? ` (${d.edadesMenores.join(', ')})` : '') : ''}</span>`).join('')}</div>` : ''}
        </div>
    `).join('')
    return `<div class="panel-section"><div class="panel-section-title">🏨 Alojamiento (${hotels.length})${totalCost > 0 ? ` — ${window.fmt(totalCost)}` : ''}</div>${rows}</div>`
}

const DINING_LABELS = { quick_service: 'Quick Service', standard: 'Disney Dining Plan' }
function _diningLabel(lead) {
    const dp = lead.parkEntries?.find(pe => pe.diningPlan)?.diningPlan || ''
    return DINING_LABELS[dp] || (dp === true ? 'Incluido' : dp || 'Incluido')
}

function renderParkEntriesPanel(lead) {
    // Pure cruise leads don't need parks section
    if (lead.type === 'crucero') return ''
    const entries = (lead.parkEntries || []).filter(p => p.park || (parseInt(p.days) > 0))
    if (entries.length === 0) {
        // Fall back to old single fields for un-migrated leads
        const t = null // old trip fallback handled by caller context
        if (lead.diasParque) {
            return `<div class="panel-section"><div class="panel-section-title">🎢 Entradas a Parques</div>
                ${lead.tipoParque ? `<div class="info-row"><span class="info-label">Parques</span><span class="info-val" style="color:var(--purple-light);font-weight:600;">${window.escHtml(lead.tipoParque)}</span></div>` : ''}
                <div class="info-row"><span class="info-label">Días</span><span class="info-val">${lead.diasParque} días</span></div>
                ${lead.ticketValidFrom ? `<div class="info-row"><span class="info-label">Válido desde</span><span class="info-val">${window.fmtDate(lead.ticketValidFrom)}</span></div>` : ''}
                ${lead.ticketValidTo ? `<div class="info-row"><span class="info-label">Válido hasta</span><span class="info-val">${window.fmtDate(lead.ticketValidTo)}</span></div>` : ''}
                ${lead.tickets ? `<div class="info-row"><span class="info-label">Tipo Ticket</span><span class="info-val">${window.escHtml(lead.tickets)}</span></div>` : ''}
                ${lead.parkHopper ? `<div class="info-row"><span class="info-label">Park Hopper</span><span class="info-val" style="color:var(--green)">✓ Sí</span></div>` : ''}
                ${lead.hasDiningPlan ? `<div class="info-row"><span class="info-label">Dining Plan</span><span class="info-val" style="color:var(--green)">✓ ${window.escHtml(_diningLabel(lead))}</span></div>` : ''}
            </div>`
        }
        return ''
    }
    const totalDays = entries.reduce((s, e) => s + (e.days || 0), 0)
    const totalCost = entries.reduce((s, e) => s + (e.cost || 0), 0)
    const rows = entries.map(p => `
        <div style="background:var(--bg-2);padding:10px;border-radius:8px;margin-bottom:6px;border-left:3px solid var(--purple-light);">
            <div style="display:flex;justify-content:space-between;align-items:center;">
                <span style="font-weight:600;font-size:13px;color:var(--purple-light);">${window.escHtml(p.park || 'Parque')}</span>
                <span style="font-size:12px;font-weight:600;">${p.days || 0} días</span>
            </div>
            ${p.validFrom || p.validTo ? `<div style="font-size:11px;color:var(--text-2);margin-top:4px;">📅 ${window.fmtDate(p.validFrom) || '?'} → ${window.fmtDate(p.validTo) || '?'}</div>` : ''}
            <div style="display:flex;gap:8px;flex-wrap:wrap;font-size:11px;color:var(--text-3);margin-top:4px;">
                ${p.ticketType ? `<span>🎟️ ${window.escHtml(p.ticketType)}</span>` : ''}
                ${p.parkHopper ? `<span style="color:var(--green);">✓ Park Hopper</span>` : ''}
                ${p.diningPlan ? `<span style="color:var(--green);">✓ ${window.escHtml(DINING_LABELS[p.diningPlan] || 'Dining Plan')}</span>` : ''}
                ${p.lightningLane ? `<span style="color:var(--green);">⚡ Lightning Lane</span>` : ''}
                ${p.expressPass ? `<span style="color:var(--green);">🎢 Express Pass</span>` : ''}
                ${p.reservationNum ? `<span>#${window.escHtml(p.reservationNum)}</span>` : ''}
                ${p.cost ? `<span style="color:var(--green);">${window.fmt(p.cost)}</span>` : ''}
            </div>
        </div>
    `).join('')
    return `<div class="panel-section"><div class="panel-section-title">🎢 Entradas a Parques (${entries.length} — ${totalDays} días)${totalCost > 0 ? ` — ${window.fmt(totalCost)}` : ''}</div>${rows}</div>`
}

// ========== MULTI-CRUISE ROW BUILDER ==========
function addCruiseRow(data = {}, container = null) {
    // Migrate: parse stateroomNum/deck from cabin string if missing (old format had all in one field)
    if (data.cabin && !data.stateroomNum) {
        const numMatch = data.cabin.match(/#(\d{3,})/)
        if (numMatch) { data.stateroomNum = numMatch[1]; data.cabin = data.cabin.replace(/,?\s*#\d{3,}/, '').trim() }
    }
    if (data.cabin && !data.deck) {
        const deckMatch = data.cabin.match(/Deck\s+(\d+)/i)
        if (deckMatch) { data.deck = deckMatch[1]; data.cabin = data.cabin.replace(/,?\s*Deck\s+\d+/i, '').trim() }
    }

    const c = container || document.getElementById('eCruisesContainer')
    const row = document.createElement('div')
    row.className = 'cruise-entry-row'
    row.style.cssText = 'background:var(--bg-2);padding:12px;border-radius:8px;margin-bottom:8px;'

    const lines = ['', 'Disney Cruise Line', 'Royal Caribbean', 'MSC Cruises', 'Norwegian', 'Carnival', 'Celebrity', 'Virgin Voyages']
    const isCustomLine = data.line && !lines.includes(data.line)
    const lineVal = isCustomLine ? '__otro__' : (data.line || '')
    const lineOpts = lines.map(l => `<option value="${l}" ${lineVal === l ? 'selected' : ''}>${l || '-- Naviera --'}</option>`).join('') +
        `<option value="__otro__" ${isCustomLine ? 'selected' : ''}>Otro...</option>`

    const cabinAgesHtml = (data.cabinEdadesMenores || []).map((age, i) =>
        `<div style="text-align:center;"><div style="font-size:9px;color:var(--text-3);">M${i + 1}</div><input type="number" class="form-input" data-field="cabinAge" value="${age}" min="0" max="17" style="width:40px;text-align:center;padding:3px;font-size:11px;" placeholder="?"></div>`
    ).join('')

    row.innerHTML = `
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;">
            <span style="font-size:11px;font-weight:600;color:var(--text-3);text-transform:uppercase;">Crucero ${c.querySelectorAll('.cruise-entry-row').length + 1}</span>
            <button type="button" class="btn btn-xs btn-ghost" onclick="this.closest('.cruise-entry-row').remove()" style="color:var(--red);">✕ Quitar</button>
        </div>
        <div class="form-row-2">
            <div class="form-group"><label class="form-label">Naviera</label>
                <select class="form-input" data-field="line" onchange="const o=this.closest('.cruise-entry-row').querySelector('[data-field=lineOtro]');o.classList.toggle('hidden',this.value!=='__otro__')">${lineOpts}</select>
                <input type="text" class="form-input ${isCustomLine ? '' : 'hidden'}" data-field="lineOtro" value="${isCustomLine ? window.escHtml(data.line) : ''}" placeholder="Nombre de la naviera" style="margin-top:6px;">
            </div>
            <div class="form-group"><label class="form-label"># Confirmación</label><input type="text" class="form-input" data-field="reservationNum" value="${window.escHtml(data.reservationNum || '')}" placeholder="Número de reserva"></div>
        </div>
        <div class="form-row-2">
            <div class="form-group"><label class="form-label">Puerto salida</label><input type="text" class="form-input" data-field="departurePort" value="${window.escHtml(data.departurePort || '')}" placeholder="Ej: Port Canaveral"></div>
            <div class="form-group"><label class="form-label">Costo (USD)</label><input type="number" class="form-input" data-field="cost" value="${data.cost != null ? data.cost : ''}" min="0" step="0.01" placeholder="0"></div>
        </div>
        <div class="form-row-2">
            <div class="form-group"><label class="form-label">Salida</label><input type="date" class="form-input" data-field="departureDate" value="${data.departureDate ? String(data.departureDate).substring(0, 10) : ''}"></div>
            <div class="form-group"><label class="form-label">Retorno</label><input type="date" class="form-input" data-field="returnDate" value="${data.returnDate ? String(data.returnDate).substring(0, 10) : ''}"></div>
        </div>
        <div class="form-row-2">
            <div class="form-group"><label class="form-label">Tipo camarote</label><input type="text" class="form-input" data-field="cabin" value="${window.escHtml(data.cabin || '')}" placeholder="Ej: Standard Inside Stateroom"></div>
            <div class="form-group"><label class="form-label"># Camarote</label><input type="text" class="form-input" data-field="stateroomNum" value="${window.escHtml(data.stateroomNum || '')}" placeholder="Ej: 8029"></div>
        </div>
        <div class="form-row-2">
            <div class="form-group"><label class="form-label">Deck</label><input type="text" class="form-input" data-field="deck" value="${window.escHtml(data.deck || '')}" placeholder="Ej: 8"></div>
            <div class="form-group" style="margin-bottom:0;"><label class="form-label">Notas</label><input type="text" class="form-input" data-field="notes" value="${window.escHtml(data.notes || '')}" placeholder="Observaciones..."></div>
        </div>
        <div style="margin-top:8px;padding-top:8px;border-top:1px dashed var(--border);">
            <div style="font-size:11px;font-weight:600;color:var(--text-3);margin-bottom:6px;">PASAJEROS EN ESTA CABINA</div>
            <div style="display:flex;gap:12px;align-items:flex-start;flex-wrap:wrap;">
                <div style="text-align:center;"><div style="font-size:9px;color:var(--text-3);">Adultos</div><input type="number" class="form-input" data-field="cabinAdultos" value="${data.cabinAdultos != null ? data.cabinAdultos : ''}" min="0" max="10" style="width:48px;text-align:center;padding:3px;font-size:12px;" placeholder="0"></div>
                <div style="text-align:center;"><div style="font-size:9px;color:var(--text-3);">Menores</div><input type="number" class="form-input" data-field="cabinMenores" value="${data.cabinMenores != null ? data.cabinMenores : ''}" min="0" max="10" style="width:48px;text-align:center;padding:3px;font-size:12px;" placeholder="0" onchange="updateCruiseCabinAges(this)"></div>
                <div class="cruise-cabin-ages" style="display:flex;gap:4px;flex-wrap:wrap;align-items:flex-end;">${cabinAgesHtml}</div>
            </div>
        </div>
    `
    c.appendChild(row)
}

function updateCruiseCabinAges(input) {
    const row = input.closest('.cruise-entry-row')
    if (!row) return
    const count = parseInt(input.value) || 0
    const container = row.querySelector('.cruise-cabin-ages')
    if (!container) return
    const existing = [...container.querySelectorAll('input')].map(i => i.value)
    let html = ''
    for (let i = 0; i < count; i++) {
        const prevVal = existing[i] || ''
        html += `<div style="text-align:center;"><div style="font-size:9px;color:var(--text-3);">M${i + 1}</div><input type="number" class="form-input" data-field="cabinAge" value="${prevVal}" min="0" max="17" style="width:40px;text-align:center;padding:3px;font-size:11px;" placeholder="?"></div>`
    }
    container.innerHTML = html
}

function collectCruisesFromForm() {
    const rows = document.querySelectorAll('#eCruisesContainer .cruise-entry-row')
    const cruises = []
    rows.forEach(row => {
        const get = (f) => row.querySelector(`[data-field="${f}"]`)
        const lineSelect = get('line')?.value
        const lineOtro = get('lineOtro')?.value?.trim()
        const line = lineSelect === '__otro__' ? lineOtro : (lineSelect || '')
        const _int = (v) => { const n = parseInt(v); return isNaN(n) ? null : n }
        const _float = (v) => { const n = parseFloat(v); return isNaN(n) ? null : n }
        const entry = {
            line,
            reservationNum: get('reservationNum')?.value?.trim() || '',
            departurePort: get('departurePort')?.value?.trim() || '',
            departureDate: get('departureDate')?.value || null,
            returnDate: get('returnDate')?.value || null,
            cabin: get('cabin')?.value?.trim() || '',
            stateroomNum: get('stateroomNum')?.value?.trim() || '',
            deck: get('deck')?.value?.trim() || '',
            cost: _float(get('cost')?.value),
            notes: get('notes')?.value?.trim() || '',
            cabinAdultos: _int(get('cabinAdultos')?.value),
            cabinMenores: _int(get('cabinMenores')?.value),
            cabinEdadesMenores: [...row.querySelectorAll('.cruise-cabin-ages input')].map(i => parseInt(i.value)).filter(n => !isNaN(n)),
        }
        if (entry.line || entry.reservationNum) cruises.push(entry)
    })
    return window.sortByDate(cruises, 'departureDate')
}

// Viajeros display: groups by family (reservationNum) when multi-reservation, flat list otherwise
function _renderViajerosCompact(l) {
    const gv = l.grupoViajeros || l.formData?.grupoViajeros || []
    if (gv.length === 0) {
        const txt = window.fmtViajeros(l, 'panel')
        if (txt) return '<div style="font-size:11px;color:var(--text-3);margin-bottom:6px;">' + window.escHtml(txt) + '</div>'
        if (l.viajeros) return '<div style="font-size:11px;color:var(--text-3);margin-bottom:6px;">' + window.escHtml(l.viajeros) + '</div>'
        return ''
    }
    // Check if we have multiple reservation groups
    const resNums = [...new Set(gv.map(v => v.reservationNum).filter(Boolean))]
    if (resNums.length <= 1) {
        // Single family — flat list
        const names = gv.map(v => {
            const name = (v.nombre || '').split(' ')[0]
            return v.esMenor && v.edad ? name + ' (' + v.edad + ')' : name
        }).filter(Boolean)
        return '<div style="font-size:11px;color:var(--text-3);margin-bottom:6px;">' + window.escHtml(names.join(', ')) + '</div>'
    }
    // Multi-family — group by reservationNum
    const cruises = l.cruises || []
    return resNums.map(rn => {
        const members = gv.filter(v => v.reservationNum === rn)
        const cr = cruises.find(c => c.reservationNum === rn)
        const familyLabel = cr?.titular ? cr.titular.split(' ').slice(0, 2).join(' ') : rn
        const names = members.map(v => {
            const name = (v.nombre || '').split(' ')[0]
            return v.esMenor && v.edad ? name + ' (' + v.edad + ')' : name
        }).filter(Boolean)
        return '<div style="font-size:11px;color:var(--text-3);margin-bottom:4px;padding:4px 6px;background:var(--bg-2);border-radius:4px;"><span style="font-weight:600;">Fam. ' + window.escHtml(familyLabel) + '</span> <span style="color:var(--text-3);">(' + members.length + ')</span>: ' + window.escHtml(names.join(', ')) + '</div>'
    }).join('')
}

function renderCruisesPanel(lead) {
    const cruises = lead.cruises || []
    if (cruises.length === 0) return ''
    const totalCost = cruises.reduce((s, c) => s + (c.totalVenta || c.cost || 0), 0)
    const multiRes = cruises.length > 1
    const rows = cruises.map(c => {
        const isPaid = c.balance != null ? c.balance <= 0 : false
        const hasFin = c.totalVenta > 0
        return `
        <div style="background:var(--bg-2);padding:10px;border-radius:8px;margin-bottom:6px;border-left:3px solid #0077b6;">
            <div style="display:flex;justify-content:space-between;align-items:center;">
                <span style="font-weight:600;font-size:13px;">${window.escHtml(c.ship || c.line || 'Crucero')}</span>
                ${c.reservationNum ? `<span style="font-size:11px;color:var(--cyan);font-family:monospace;">#${window.escHtml(c.reservationNum)}</span>` : ''}
            </div>
            ${multiRes && c.titular ? `<div style="font-size:11px;color:var(--text-2);margin-top:2px;">Fam. ${window.escHtml(c.titular)}</div>` : ''}
            ${c.departureDate || c.returnDate ? `<div style="font-size:11px;color:var(--text-2);margin-top:4px;">📅 ${window.fmtDate(c.departureDate) || '?'} → ${window.fmtDate(c.returnDate) || '?'}</div>` : ''}
            <div style="display:flex;gap:12px;font-size:11px;color:var(--text-3);margin-top:4px;flex-wrap:wrap;">
                ${c.departurePort ? `<span>📍 ${window.escHtml(c.departurePort)}</span>` : ''}
                ${c.cabin ? `<span>🛏️ ${window.escHtml(c.cabin)}</span>` : ''}
                ${c.stateroomNum ? `<span>🚪 #${window.escHtml(c.stateroomNum)}</span>` : ''}
                ${c.deck ? `<span>⬆️ Deck ${window.escHtml(c.deck)}</span>` : ''}
            </div>
            ${hasFin ? `<div style="display:flex;justify-content:space-between;align-items:center;margin-top:6px;padding-top:6px;border-top:1px solid var(--border);">
                <span style="font-size:12px;font-weight:600;color:var(--green);">${window.fmt(c.totalVenta)}</span>
                <span style="font-size:11px;padding:2px 8px;border-radius:10px;background:${isPaid ? 'rgba(16,185,129,0.15)' : 'rgba(245,158,11,0.15)'};color:${isPaid ? 'var(--green)' : 'var(--yellow)'};">
                    ${isPaid ? 'Pagado' : 'Saldo: ' + window.fmt(c.balance || 0)}
                </span>
            </div>
            ${c.commission ? `<div style="font-size:10px;color:var(--text-3);margin-top:2px;">Comisión: ${window.fmt(c.commission)}</div>` : ''}` : (c.cost ? `<div style="font-size:12px;color:var(--green);margin-top:4px;">${window.fmt(c.cost)}</div>` : '')}
            ${(c.cabinAdultos || c.cabinMenores) ? `<div style="font-size:11px;color:var(--text-2);margin-top:4px;">👥 ${c.cabinAdultos || 0}A${c.cabinMenores ? ` + ${c.cabinMenores}M` + ((c.cabinEdadesMenores || []).length ? ` (${window.escHtml(String(c.cabinEdadesMenores.join(', ')))})` : '') : ''}</div>` : ''}
            ${c.notes ? `<div style="font-size:11px;color:var(--text-3);margin-top:4px;font-style:italic;">${window.escHtml(c.notes)}</div>` : ''}
        </div>`
    }).join('')
    return `<div class="panel-section"><div class="panel-section-title">🚢 Cruceros (${cruises.length})${totalCost > 0 ? ` — ${window.fmt(totalCost)}` : ''}</div>${rows}</div>`
}

function renderConfirmationsPanel(lead) {
    const nums = []
    if (lead.reservationNum) nums.push({ label: lead.platform || 'Principal', num: lead.reservationNum })
    ;(lead.hotels || []).forEach(h => { if (h.reservationNum) nums.push({ label: h.provider ? `${h.provider} — ${h.name || 'Hotel'}` : (h.name || 'Hotel'), num: h.reservationNum }) })
    ;(lead.parkEntries || []).forEach(p => { if (p.reservationNum) nums.push({ label: p.park || 'Parques', num: p.reservationNum }) })
    ;(lead.cruises || []).forEach(c => { if (c.reservationNum) nums.push({ label: c.line || 'Crucero', num: c.reservationNum }) })
    if (nums.length === 0) return ''
    const rows = nums.map(n => `<div style="display:flex;justify-content:space-between;align-items:center;padding:6px 8px;background:var(--bg-2);border-radius:6px;margin-bottom:4px;">
        <span style="font-size:11px;color:var(--text-3);">${window.escHtml(n.label)}</span>
        <span style="font-size:12px;font-weight:600;color:var(--cyan);font-family:monospace;">${window.escHtml(n.num)}</span>
    </div>`).join('')
    return `<div class="panel-section"><div class="panel-section-title">📋 Confirmaciones (${nums.length})</div>${rows}</div>`
}

// ========== COPY LEAD TO EXCEL (tab-separated for paste into VENTAS) ==========
function copyLeadToExcel() {
    const id = store.currentLeadId
    const { leads, historico, clients } = store
    const all = [...leads, ...historico]
    // Try by current ID, then _supabaseId, then panel title name
    let l = id ? all.find(x => x.id === id) : null
    if (!l && id) l = all.find(x => x._supabaseId === id)
    if (!l) {
        const panelName = document.getElementById('panelTitle')?.textContent
        if (panelName && panelName !== 'Detalle') l = all.find(x => x.titular === panelName)
    }
    if (!l) { window.toast('No hay lead seleccionado', 'error'); return }

    const c = clients[l.clientKey]

    // Format date as "d mmm" (e.g. "5 ene") for Excel
    const meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
    function fmtExcelDate(d) {
        if (!d) return ''
        const parts = typeof d === 'string' && d.match(/^\d{4}-\d{2}-\d{2}/) ? d.substring(0, 10).split('-').map(Number) : null
        if (!parts) { const dt = new Date(d); if (isNaN(dt)) return ''; return `${dt.getDate()} ${meses[dt.getMonth()]}` }
        return `${parts[2]} ${meses[parts[1] - 1]}`
    }
    function fmtExcelDateFull(d) {
        if (!d) return ''
        const parts = typeof d === 'string' && d.match(/^\d{4}-\d{2}-\d{2}/) ? d.substring(0, 10).split('-').map(Number) : null
        if (!parts) return ''
        return `${parts[2]}/${parts[1]}/${parts[0]}`
    }

    // Client name with contacto in parens
    let clientName = l.titular || ''
    if (l.contacto && l.contacto !== l.titular) clientName += ` (${l.contacto})`

    // Booking date (createdAt)
    const bookingDate = fmtExcelDate(l.createdAt)

    // Travel dates
    const travelDate = fmtExcelDate(l.travelDate)
    const travelEnd = fmtExcelDate(l.travelEnd)

    // Abono date columns: deposit deadline and final payment deadline
    const fechaAbono = l.fechaAbono ? fmtExcelDate(l.fechaAbono) : '-'
    const fechaPagoFinal = l.fechaPagoFinal ? fmtExcelDate(l.fechaPagoFinal) : '-'

    // Hoy (today's date in d/m/yyyy)
    const today = new Date()
    const hoy = `${today.getDate()}/${today.getMonth() + 1}/${today.getFullYear()}`

    // Días restantes (from today to travel date)
    let diasRestantes = ''
    if (l.travelDate) {
        const td = new Date(l.travelDate)
        if (!isNaN(td)) {
            diasRestantes = Math.ceil((td - today) / 86400000)
        }
    }

    // Reservation number
    const resNum = l.reservationNum || ''

    // Detalle — human-friendly summary (e.g. "Hotel + Parques + Dining Plan")
    let detalle = ''
    const detParts = []
    if (l.hotel || (l.hotels && l.hotels.length > 0)) detParts.push('Hotel')
    if (l.diasParque || (l.parkEntries && l.parkEntries.length > 0)) {
        const dias = l.diasParque || l.parkEntries?.reduce((s, p) => s + (parseInt(p.days) || 0), 0) || 0
        detParts.push(dias > 0 ? `${dias} Parques` : 'Parques')
    }
    if (l.hasDiningPlan) detParts.push(_diningLabel(l))
    if (l.cruises && l.cruises.length > 0) detParts.push('Crucero')
    if (l.tickets && detParts.length === 0) detParts.push(l.detalle || l.tickets)
    detalle = detParts.length > 0 ? detParts.join(' + ') : (l.detalle || '')

    // Plan Preliminar — concise (e.g. "3 Parques Disney (2 adultos + Thaliana y Thiago (7 y 1))")
    let planPreliminar = ''
    if (l.grupoViajeros && l.grupoViajeros.length > 0) {
        const minors = l.grupoViajeros.filter(v => v.esMenor)
        const adults = l.grupoViajeros.filter(v => !v.esMenor)
        const parts = []
        // Park info prefix (e.g. "3 Parques Disney")
        const dias = l.diasParque || l.parkEntries?.reduce((s, p) => s + (parseInt(p.days) || 0), 0) || 0
        if (dias > 0) {
            const brand = l.type === 'disney' ? ' Disney' : l.type === 'universal' ? ' Universal' : ''
            parts.push(`${dias} Parques${brand}`)
        }
        // Cruise info (e.g. "Disney Wish desde Port Canaveral")
        if (l.cruises && l.cruises.length > 0) {
            const cr = l.cruises[0]
            // Prefer ship name over line name
            let cruisePart = cr.ship || cr.line || 'Crucero'
            if (cr.departurePort) {
                // Normalize port to Title Case (CANAVERAL → Port Canaveral)
                let port = cr.departurePort
                if (port === port.toUpperCase() && port.length > 3) {
                    port = port.charAt(0) + port.slice(1).toLowerCase()
                    if (!port.toLowerCase().startsWith('port')) port = 'Port ' + port
                }
                cruisePart += ` desde ${port}`
            }
            parts.push(cruisePart)
        }
        // Travelers summary
        const travelerParts = []
        if (adults.length > 0) travelerParts.push(`${adults.length} adulto${adults.length > 1 ? 's' : ''}`)
        if (minors.length > 0) {
            const names = minors.map(m => (m.nombre || '').split(' ')[0]).join(' y ')
            const ages = minors.map(m => m.edad || '?').join(' y ')
            travelerParts.push(`${names} (${ages})`)
        }
        if (travelerParts.length > 0) {
            parts.push(travelerParts.join(' + '))
        }
        planPreliminar = parts.length > 1 ? `${parts[0]} (${parts.slice(1).join(' + ')})` : parts.join('')
    }

    // Hotel — for cruises, show itinerary destination (e.g. "Bahamas"); for others, hotel name
    let hotel = ''
    const hotels = l.hotels && l.hotels.length > 0 ? l.hotels : []
    if (hotels.length > 0) hotel = hotels[0].name || ''
    else if (l.type === 'crucero' && l.cruises && l.cruises.length > 0) {
        // Extract itinerary destination from cruise name (e.g. "3-Night Bahamian Cruise from Port Canaveral" → "Bahamas")
        const cruiseName = l.cruises[0].notes || l.destination || ''
        const itinMatch = cruiseName.match(/(\w+)\s+Cruise/i)
        if (itinMatch) {
            // Convert adjective to noun: "Bahamian" → "Bahamas", "Caribbean" stays, "Mexican" → "México"
            const adj = itinMatch[1]
            const adjToNoun = { 'bahamian': 'Bahamas', 'caribbean': 'Caribbean', 'mexican': 'México', 'alaskan': 'Alaska', 'bermuda': 'Bermuda', 'european': 'Europa', 'mediterranean': 'Mediterráneo', 'transatlantic': 'Transatlántico', 'hawaiian': 'Hawaii', 'canadian': 'Canadá' }
            hotel = adjToNoun[adj.toLowerCase()] || adj
        }
    } else if (l.hotel) hotel = l.hotel

    // Destination — use short name matching Excel convention (WDW, Universal Orlando, DCL, etc.)
    let destination = l.destination || ''
    if (l.type === 'crucero') {
        // Cruise: always use short code
        const lineShort = { 'Disney Cruise Line': 'DCL', 'Royal Caribbean': 'RC', 'MSC Cruises': 'MSC', 'Norwegian': 'NCL', 'Carnival': 'Carnival', 'Celebrity': 'Celebrity' }
        const cr = l.cruises?.[0]
        destination = (cr && lineShort[cr.line]) || lineShort[l.platform] || l.platform || 'Crucero'
    } else if (destination === hotel && hotel) {
        if (l.type === 'disney' || l.tipoParque === 'Disney World') destination = 'WDW'
        else if (l.type === 'universal') destination = 'Universal Orlando'
    }
    // Common full-name to short-name mapping
    if (destination.includes("Disney's ") && destination.includes('Resort')) destination = 'WDW'
    if (destination === 'Walt Disney World') destination = 'WDW'

    // Platform — use brand name for Excel (Disney Cruise Line → Disney, etc.)
    let platform = l.platform || ''
    const platformShort = { 'Disney Cruise Line': 'Disney', 'Royal Caribbean': 'Royal Caribbean', 'MSC Cruises': 'MSC', 'Expedia TAAP': 'Expedia TAAP' }
    platform = platformShort[platform] || platform

    // Monetary values — exact with 2 decimal places
    const totalVenta = l.totalVenta ? parseFloat(l.totalVenta).toFixed(2) : ''
    const totalCommission = l.commission ? parseFloat(l.commission).toFixed(2) : ''
    const commission70 = l.commission70 ? parseFloat(l.commission70).toFixed(2) : ''

    // Guía, Plan, Reunión, Encuesta — not tracked in CRM yet, leave blank
    const guia = ''
    const plan = ''
    const reunion = ''
    const encuesta = ''

    // Build tab-separated row matching Excel VENTAS 2026 columns
    const columns = [
        clientName,         // Client Name
        c?.email || l.email || '',  // Email
        c?.phone || l.phone || '',  // Celular
        guia,               // Guía
        plan,               // Plan
        reunion,            // Reunión
        encuesta,           // Encuesta
        bookingDate,        // Booking Date
        travelDate,         // Travel Date
        travelEnd,          // Travel End
        fechaAbono,         // Abono (deposit deadline date)
        fechaPagoFinal,     // Abono (final payment deadline date)
        hoy,                // Hoy
        diasRestantes,      // Días restantes
        resNum,             // Reservation Number
        detalle,            // Detalle
        planPreliminar,     // Plan Preliminar
        hotel,              // Hotel
        destination,        // Destination
        platform,           // Platform
        totalVenta,         // Total Venta
        totalCommission,    // Total Commission
        commission70        // 70% Commission
    ]

    const row = columns.map(v => String(v ?? '')).join('\t')

    navigator.clipboard.writeText(row).then(() => {
        window.toast('📋 Copiado para Excel VENTAS (23 columnas)', 'success')
    }).catch(() => {
        // Fallback
        const ta = document.createElement('textarea')
        ta.value = row
        document.body.appendChild(ta)
        ta.select()
        document.execCommand('copy')
        document.body.removeChild(ta)
        window.toast('📋 Copiado para Excel VENTAS', 'success')
    })
}

Object.assign(window, {
    showDupAlert, checkDupByPhone, checkDupByEmail, checkDupByName,
    ignoreDup, viewDupClient,
    saveLead, openEditLead, saveLeadEdit,
    toggleAbonoPagado, togglePagoTotalidad,
    togglePlatformOtro, getPlatformValue,
    checkAutoStage,
    toggleAbonoFromPanel, togglePagoTotalFromPanel,
    deleteLead, editFromPanel, toggleWatchLead,
    changeResponsableFromPanel,
    openLead,
    addHotelRow, addParkEntryRow, updateParkAddons,
    addCruiseRow, collectCruisesFromForm, updateCruiseCabinAges,
    collectHotelsFromForm, collectParkEntriesFromForm,
    updateHotelRoomDistribution, updateHotelRoomAges,
    renderHotelsPanel, renderParkEntriesPanel, renderCruisesPanel,
    copyLeadToExcel,
    stepViajeros, updateMinorAgeDropdowns, getMinorAges,
    renderViajerosEditList, syncMinorAgeFromViajero, collectViajerosFromForm,
    updateParkTicketCounts, stepParkTickets,
})
